// @generated by liquid-inject from src/sections/algolia-main-collection/algolia-main-collection.ts
// src/sections/algolia-main-search/constants.ts
var CDN_ALGOLIASEARCH = "https://cdn.jsdelivr.net/npm/algoliasearch@5.56.0/dist/lite/builds/browser.umd.js";
var SRI_ALGOLIASEARCH = "sha384-jydndPKly6IFOH8FPmOV3qHV/YxfBbkZBbaNHhojUEnFzJpw458cQC2x80yc6cdb";
var CDN_INSTANTSEARCH = "https://cdn.jsdelivr.net/npm/instantsearch.js@4.107.0/dist/instantsearch.production.min.js";
var SRI_INSTANTSEARCH = "sha384-jQzNjxEgDf9zvtGMhSQ2tONwoAaad2xzhQAgXKs5ULIao/KSpT/4eC0ddEYvq2S7";
var CDN_SEARCH_INSIGHTS = "https://cdn.jsdelivr.net/npm/search-insights@2.17.3/dist/search-insights.min.js";
var SRI_SEARCH_INSIGHTS = "sha384-puGTibgj5tll4rKBSZMNWXFBG+MuObLcSQE3VnZ/PbPozbHGK7qhg0CFKG9FBUjZ";
var SEARCH_DEBOUNCE_MS = 200;
var MIN_QUERY_LEN = 3;
var ALGOLIA_HITS_PER_PAGE = 48;
var ALGOLIA_MAX_INITIAL_PRELOAD_PAGES = 3;
var ALGOLIA_MAX_VALUES_PER_FACET = 50;
var ALGOLIA_HIDDEN_FACET_ATTRIBUTES = ["tags", "collections"];
var ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE = [
  "objectID",
  "id",
  "handle",
  "url",
  "title",
  "image",
  "price",
  "available",
  "inventory_available",
  "inventory_quantity",
  "variant_id",
  "template_suffix",
  "tags",
  "contenance",
  "subtitle",
  "related_products",
  "meta.custom.subtitle",
  "meta.custom.label",
  "meta.custom.contenance",
  "meta.custom.capacity",
  "meta.custom.format",
  "meta.custom.media_tags",
  "meta.custom.product_tags",
  "meta.custom.related_products",
  "meta.custom.gift_product",
  "meta.bundle"
];
var ICON_BULLET = `<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'><path d='M9.5 8C9.5 8.55228 9.05228 9 8.5 9C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7C9.05228 7 9.5 7.44772 9.5 8Z' fill='currentColor'/></svg>`;
var ICON_CROSS_SVG = `<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' aria-hidden='true'><path d='M18 6L6 18M6 6l12 12' stroke='currentColor' stroke-width='1.5' stroke-linecap='round'/></svg>`;
var ICON_PLUS = `<svg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'><path d="M6.09082 2C6.11999 2.00012 6.13481 2.01315 6.15918 2.02637C6.1936 2.03968 6.24306 2.05346 6.25781 2.08008C6.2772 2.10655 6.25781 2.11994 6.25781 2.14648L6.22363 2.06641C6.25278 2.10617 6.16969 2.15938 6.18359 2.19922C6.19831 2.25234 6.18852 2.29264 6.18359 2.3457C6.18359 2.37233 6.19416 2.39977 6.21875 2.41309C6.24226 2.43955 6.18938 2.46626 6.25781 2.47949C6.25792 2.53268 6.28725 2.5992 6.25293 2.65234C6.21367 2.71876 6.23819 2.78515 6.22363 2.85156C6.30221 2.9579 6.24329 3.06456 6.25781 3.1709C6.25781 3.19752 6.27766 3.23839 6.22852 3.27832C6.18917 3.30494 6.26224 3.34447 6.18848 3.37109H6.20312C6.21257 3.37109 6.2269 3.39552 6.22363 3.39746C6.18429 3.46402 6.18429 3.46397 6.22363 3.50391C6.22363 3.50391 6.19824 3.51794 6.19824 3.53125C6.19813 3.55759 6.18869 3.58401 6.19824 3.61035C6.20316 3.63697 6.16455 3.66381 6.2334 3.69043C6.24741 3.69065 6.23365 3.70372 6.2334 3.7168V3.79688C6.23832 3.8235 6.20857 3.864 6.26758 3.89062C6.29174 3.89072 6.22897 3.91636 6.23828 3.92969C6.26261 3.94288 6.27221 3.95654 6.26758 3.96973C6.26758 3.98293 6.23866 3.99656 6.2334 4.00977C6.23523 4.01142 6.26276 4.03692 6.26758 4.0498C6.2725 4.07643 6.24292 4.11693 6.27734 4.14355C6.31132 4.17 6.30187 4.19621 6.30664 4.22266V4.31641C6.31134 4.34287 6.28229 4.35627 6.26758 4.38281C6.25291 4.40937 6.30172 4.42269 6.2334 4.44922C6.22359 4.48906 6.20322 4.54213 6.19824 4.58203C6.19332 4.6619 6.19824 4.7424 6.19824 4.82227C6.19842 4.84869 6.22285 4.86215 6.16406 4.88867C6.15446 4.88878 6.16896 4.90137 6.16406 4.90137C6.13456 4.92799 6.23765 4.94177 6.18848 4.95508C6.14458 4.96842 6.16897 4.9955 6.16406 5.00879C6.15929 5.0351 6.16406 5.04873 6.16406 5.0752C6.16414 5.08837 6.16916 5.10206 6.20312 5.11523C6.13988 5.12858 6.18373 5.15469 6.1543 5.16797C6.13464 5.16801 6.11508 5.19471 6.13965 5.20801C6.18866 5.23456 6.16415 5.2479 6.16895 5.27441C6.17877 5.30101 6.15411 5.34154 6.20312 5.36816C6.22275 5.36816 6.21294 5.39389 6.20312 5.40723C6.19824 5.42046 6.17406 5.43403 6.16895 5.44727C6.16404 5.47381 6.16896 5.5008 6.19824 5.52734C6.22775 5.55397 6.16943 5.58044 6.23828 5.59375C6.24766 5.59375 6.24314 5.59429 6.23828 5.60742C6.20878 5.63404 6.19406 5.64721 6.2334 5.67383C6.26263 5.7004 6.23828 5.72734 6.23828 5.75391C6.23832 5.77114 6.24187 5.78843 6.24219 5.80566C6.26561 5.80624 6.28907 5.80566 6.3125 5.80566C6.3125 5.80566 6.32653 5.82042 6.33984 5.80566C6.35316 5.74173 6.37927 5.70239 6.39258 5.80566C6.40589 5.73682 6.43298 5.77148 6.44629 5.77148C6.51271 5.78094 6.57948 5.702 6.65918 5.73145C6.66236 5.72982 6.68678 5.71848 6.69922 5.74121C6.71245 5.78521 6.72543 5.71295 6.72559 5.73145C6.72559 5.74616 6.75228 5.71694 6.76562 5.73633C6.79214 5.80491 6.83178 5.78617 6.8584 5.76172C6.88496 5.74209 6.91191 5.7169 6.93848 5.74121C6.96513 5.76337 6.98839 5.77027 7.01172 5.77148H7.23145C7.25796 5.77159 7.27128 5.79522 7.29785 5.73633C7.29785 5.72699 7.29838 5.73147 7.31152 5.73633C7.32481 5.7462 7.33827 5.77148 7.35156 5.77148C7.36469 5.77093 7.37749 5.74609 7.39062 5.73633C7.39124 5.72706 7.41751 5.73619 7.43066 5.70703C7.43078 5.68281 7.45737 5.70705 7.4707 5.73633C7.49733 5.80026 7.53783 5.86436 7.56445 5.84961C7.59107 5.84002 7.63074 5.84961 7.65723 5.84961C7.67054 5.84961 7.68395 5.84978 7.69727 5.8252C7.69729 5.80075 7.7365 5.81057 7.75 5.8252C7.7766 5.85468 7.80348 5.85952 7.83008 5.8252C7.83009 5.81063 7.84329 5.8152 7.85645 5.81055H8.03027C8.04347 5.81039 8.05711 5.80085 8.07031 5.84473C8.07036 5.79132 8.09596 5.8103 8.10938 5.81543C8.12267 5.82034 8.14976 5.84466 8.16309 5.84961C8.18969 5.85452 8.20291 5.84976 8.22949 5.82031C8.25606 5.79086 8.26938 5.8397 8.2959 5.7959C8.2959 5.78606 8.29626 5.81543 8.30957 5.81543C8.33615 5.8057 8.36307 5.85472 8.38965 5.78125C8.41608 5.85408 8.44232 5.80115 8.46875 5.78125C8.49537 5.76158 8.53588 5.82031 8.5625 5.82031C8.60238 5.82027 8.62905 5.79575 8.66895 5.82031C8.72213 5.86939 8.78859 5.84475 8.8418 5.84961C8.89493 5.85452 8.96146 5.84963 9.01465 5.84961C9.04123 5.84961 9.06814 5.82041 9.09473 5.81543H9.25488C9.25725 5.8138 9.28226 5.79773 9.29492 5.83984V5.84473C9.32144 5.79587 9.33476 5.80056 9.36133 5.84473C9.36133 5.85946 9.3744 5.84475 9.3877 5.84961C9.41427 5.86924 9.42758 5.82538 9.4541 5.81055C9.4674 5.79581 9.49448 5.84484 9.50781 5.77637C9.50781 5.76654 9.50723 5.76655 9.52051 5.77637C9.56042 5.88905 9.60072 5.70245 9.64062 5.80566C9.65394 5.74173 9.66735 5.8155 9.68066 5.80566C9.69391 5.79098 9.70703 5.77651 9.7334 5.77637H9.83398C9.8505 5.77629 9.86667 5.7705 9.87988 5.74609C9.88027 5.72671 9.90671 5.71779 9.91992 5.77148V5.77637C9.94654 5.7567 10 5.81083 10 5.90918V6.09082C9.99999 6.12012 9.98686 6.13487 9.97363 6.15918C9.96032 6.1936 9.94654 6.24306 9.91992 6.25781C9.89334 6.27741 9.88012 6.25781 9.85352 6.25781L9.93359 6.22363C9.89375 6.25307 9.84068 6.17031 9.80078 6.18457C9.74768 6.19929 9.70733 6.1895 9.6543 6.18457C9.62767 6.18457 9.60023 6.19416 9.58691 6.21875C9.56041 6.24265 9.53378 6.18938 9.52051 6.25781C9.46731 6.25792 9.4008 6.28729 9.34766 6.25293C9.28126 6.21376 9.21483 6.23821 9.14844 6.22363C9.04211 6.30219 8.93543 6.24331 8.8291 6.25781C8.80248 6.25781 8.76161 6.27769 8.72168 6.22852C8.69509 6.18962 8.65549 6.26265 8.62891 6.18945V6.2041C8.62851 6.21387 8.60289 6.22822 8.60254 6.22363C8.53603 6.18432 8.53594 6.18438 8.49609 6.22363C8.49609 6.22363 8.48206 6.19922 8.46875 6.19922C8.44234 6.19911 8.41606 6.18955 8.38965 6.19922C8.36303 6.20414 8.33619 6.16458 8.30957 6.2334C8.30956 6.24801 8.2964 6.23364 8.2832 6.2334H8.20312C8.17651 6.23832 8.136 6.2086 8.10938 6.26758C8.10938 6.29198 8.08372 6.22963 8.07031 6.23828C8.05707 6.26274 8.04352 6.27231 8.03027 6.26758C8.01703 6.26758 8.00348 6.23853 7.99023 6.2334C7.99023 6.2334 7.96356 6.26247 7.9502 6.26758C7.92357 6.2725 7.88307 6.24292 7.85645 6.27734C7.8299 6.31164 7.80389 6.30279 7.77734 6.30762H7.68359C7.6572 6.31222 7.6437 6.28227 7.61719 6.26758C7.59069 6.25316 7.57734 6.30205 7.55078 6.2334C7.51097 6.22359 7.45786 6.20421 7.41797 6.19922C7.3381 6.1943 7.2576 6.19922 7.17773 6.19922C7.15131 6.1994 7.13785 6.22285 7.11133 6.16406C7.11089 6.15521 7.09863 6.1689 7.09863 6.16406C7.07208 6.13472 7.0582 6.23788 7.04492 6.18945C7.03161 6.14519 7.00452 6.16898 6.99121 6.16406C6.96495 6.15931 6.95125 6.16406 6.9248 6.16406C6.9116 6.16414 6.89797 6.16995 6.88477 6.2041C6.87145 6.14017 6.84534 6.1838 6.83203 6.1543C6.83167 6.13482 6.80525 6.11557 6.79199 6.13965C6.76538 6.1888 6.75218 6.16504 6.72559 6.16992C6.69896 6.17972 6.65845 6.15495 6.63184 6.2041C6.63163 6.22329 6.60615 6.2138 6.59277 6.2041C6.57961 6.19924 6.5659 6.17521 6.55273 6.16992C6.52611 6.165 6.49928 6.16971 6.47266 6.19922C6.44607 6.22851 6.41956 6.16981 6.40625 6.23828C6.40625 6.24812 6.40589 6.2432 6.39258 6.23828C6.366 6.20882 6.35277 6.1941 6.32617 6.2334C6.29955 6.2629 6.27272 6.23828 6.24609 6.23828C6.23538 6.23831 6.22458 6.2403 6.21387 6.24219C6.21296 6.2772 6.2512 6.30305 6.17871 6.33984C6.23772 6.36647 6.18917 6.39232 6.22852 6.41895C6.25279 6.43214 6.25293 6.44579 6.25293 6.45898V6.73828C6.25293 6.79153 6.27727 6.85886 6.28711 6.91211C6.28725 6.9253 6.29659 6.93852 6.25781 6.96484C6.22831 6.97815 6.22817 7.00524 6.27734 7.01855H6.28711C6.19877 7.05846 6.28708 7.08508 6.29199 7.125C6.29678 7.19142 6.24324 7.2578 6.25293 7.32422C6.25293 7.33753 6.22815 7.35095 6.28711 7.36426C6.23807 7.36426 6.26258 7.37735 6.28711 7.39062C6.3117 7.40394 6.3117 7.43103 6.28711 7.44434C6.24804 7.45757 6.26248 7.47076 6.25781 7.49707V7.55078C6.24798 7.61729 6.23349 7.69715 6.21875 7.76367C6.21875 7.77698 6.19343 7.7904 6.18359 7.80371C6.1741 7.81697 6.2033 7.83049 6.14941 7.84375C6.12981 7.84376 6.14932 7.85684 6.14941 7.87012C6.14941 7.91001 6.12001 7.93669 6.15918 7.97656C6.19852 8.00318 6.14987 8.04369 6.22363 8.07031C6.24234 8.07071 6.22406 8.09603 6.22363 8.10938C6.2433 8.14931 6.17913 8.20323 6.25781 8.24316C6.20876 8.25644 6.2187 8.28256 6.22363 8.2959C6.22363 8.30921 6.19883 8.32263 6.25293 8.33594C6.23818 8.34925 6.20306 8.36303 6.21289 8.38965C6.22273 8.40296 6.25785 8.41638 6.25293 8.42969C6.25267 8.49589 6.18886 8.54905 6.21289 8.61523C6.16899 8.62858 6.17873 8.65567 6.17383 8.66895C6.17388 8.70885 6.22764 8.73548 6.21289 8.77539C6.20311 8.80187 6.18892 8.8416 6.21289 8.86816C6.26207 8.92141 6.23333 8.97508 6.24316 9.02832C6.2432 9.04162 6.26202 9.05506 6.21289 9.06836C6.19882 9.06864 6.20904 9.08156 6.22363 9.09473C6.25735 9.09484 6.23845 9.10788 6.24805 9.12109C6.28247 9.14772 6.14477 9.17517 6.24805 9.18848V9.3623C6.24631 9.37063 6.24079 9.38095 6.22363 9.3877C6.19904 9.3877 6.19416 9.41442 6.21875 9.42773C6.26731 9.44108 6.24806 9.46762 6.24805 9.49414C6.24805 9.5607 6.25296 9.61411 6.24805 9.68066C6.24797 9.70724 6.22271 9.73416 6.21289 9.76074C6.2036 9.78721 6.23738 9.81337 6.18848 9.83984C6.19831 9.83984 6.21293 9.86719 6.20801 9.86719C6.20722 9.88039 6.1592 9.89402 6.17871 9.90723C6.21783 9.92046 6.17905 9.93305 6.16895 9.94629C6.15911 9.98622 6.05553 10 5.9375 10H5.85938C5.7266 9.97338 5.7364 9.97317 5.72656 9.91992C5.7169 9.85346 5.79019 9.79989 5.76562 9.7334C5.83442 9.6935 5.79101 9.65416 5.80566 9.61426C5.82042 9.57432 5.8743 9.5204 5.83496 9.48047C5.79578 9.44064 5.80562 9.40115 5.80566 9.36133C5.80566 9.33471 5.83493 9.2942 5.83984 9.26758C5.84458 9.24096 5.83004 9.20131 5.84473 9.1748C5.85455 9.14823 5.89835 9.13494 5.87402 9.1084C5.81997 9.06849 5.86435 9.02819 5.83496 8.98828C5.79562 8.93504 5.81951 8.86867 5.79492 8.81543C5.78018 8.78884 5.76562 8.76157 5.76562 8.72168C5.76563 8.70861 5.7662 8.69569 5.79004 8.68262C5.81463 8.66931 5.81962 8.64222 5.78027 8.62891C5.7657 8.62852 5.75135 8.6028 5.76562 8.60254C5.81972 8.57592 5.79984 8.54908 5.79492 8.52246C5.79492 8.50915 5.84483 8.48206 5.8252 8.46875C5.79077 8.45544 5.80472 8.42933 5.7998 8.41602C5.79818 8.41364 5.78329 8.38864 5.83008 8.37598C5.8444 8.3758 5.84447 8.36253 5.83496 8.3623C5.77103 8.34899 5.80472 8.32252 5.7998 8.2959V8.13672C5.7998 8.09679 5.73615 8.05617 5.76074 8.00293C5.69749 7.97647 5.7263 7.95029 5.72656 7.92383C5.72656 7.89721 5.75091 7.88307 5.76074 7.85645C5.77036 7.83007 5.76074 7.81651 5.79004 7.79004C5.82436 7.76349 5.79025 7.72389 5.7998 7.69727C5.7998 7.68395 5.77107 7.65687 5.83008 7.64355C5.76615 7.61693 5.78596 7.59046 5.81055 7.57715C5.84931 7.55056 5.83012 7.5109 5.83984 7.48438C5.84476 7.45775 5.83984 7.43092 5.83984 7.4043C5.83983 7.39099 5.83001 7.36488 5.85938 7.35156C5.879 7.33828 5.84488 7.31119 5.83984 7.29785V7.07129C5.84489 7.04486 5.86912 7.03141 5.87402 7.00488C5.88375 6.95167 5.81527 6.89854 5.83984 6.83203C5.79558 6.81872 5.82509 6.8053 5.83984 6.79199C5.8497 6.77873 5.86923 6.76479 5.82031 6.73828C5.80566 6.73828 5.81042 6.73863 5.80566 6.72559C5.80076 6.71232 5.84424 6.69881 5.80566 6.68555C5.78108 6.68555 5.80472 6.65882 5.7998 6.64551C5.79532 6.63213 5.82921 6.60547 5.77051 6.60547C5.85411 6.57885 5.72628 6.55201 5.76562 6.52539C5.78034 6.52539 5.78027 6.5123 5.79004 6.49902C5.79004 6.49902 5.80442 6.49937 5.7998 6.48633C5.72118 6.41978 5.78533 6.33901 5.76074 6.27246C5.75816 6.27068 5.74054 6.25841 5.73145 6.24609C5.73145 6.24609 5.72677 6.24632 5.73145 6.2334C5.73526 6.22823 5.73643 6.22178 5.73926 6.21777C5.71333 6.22521 5.68984 6.23807 5.66016 6.17969C5.63364 6.23788 5.60757 6.18953 5.58105 6.22852C5.56783 6.25295 5.55424 6.25293 5.54102 6.25293H5.26172C5.20847 6.25293 5.14114 6.27727 5.08789 6.28711C5.07468 6.28725 5.06158 6.29687 5.03516 6.25781C5.02186 6.2284 4.99477 6.22841 4.98145 6.27734V6.28711C4.94161 6.19926 4.91487 6.28708 4.875 6.29199C4.80859 6.29679 4.74219 6.24328 4.67578 6.25293C4.6625 6.25293 4.64902 6.22859 4.63574 6.28711C4.63568 6.23873 4.62257 6.26274 4.60938 6.28711C4.59606 6.3117 4.56898 6.3117 4.55566 6.28711C4.54246 6.24841 4.52921 6.2625 4.50293 6.25781H4.44922C4.3827 6.24798 4.30285 6.23349 4.23633 6.21875C4.22306 6.21875 4.20955 6.19447 4.19629 6.18457C4.18298 6.17474 4.16956 6.20351 4.15625 6.14941C4.15608 6.13041 4.14307 6.14931 4.12988 6.14941C4.09005 6.14941 4.06321 6.12027 4.02344 6.15918C3.99682 6.19852 3.95631 6.14987 3.92969 6.22363C3.92961 6.24295 3.90406 6.22405 3.89062 6.22363C3.8507 6.2433 3.79677 6.17918 3.75684 6.25781C3.74358 6.20914 3.71746 6.2187 3.7041 6.22363C3.6908 6.22363 3.67736 6.19904 3.66406 6.25293C3.65075 6.23818 3.63697 6.20403 3.61035 6.21387C3.59713 6.22396 3.58354 6.25781 3.57031 6.25293C3.50405 6.25267 3.45104 6.18964 3.38477 6.21387C3.37148 6.1697 3.34439 6.17965 3.33105 6.1748C3.29117 6.17486 3.2645 6.22857 3.22461 6.21387C3.19803 6.20405 3.15846 6.18945 3.13184 6.21387C3.07859 6.26304 3.02492 6.23333 2.97168 6.24316C2.95839 6.2432 2.94493 6.26287 2.93164 6.21387C2.93164 6.19912 2.91858 6.20889 2.90527 6.22363C2.90525 6.2577 2.89211 6.23871 2.87891 6.24805C2.85229 6.28247 2.82484 6.14484 2.81152 6.24805H2.65234C2.65234 6.24805 2.62562 6.25798 2.6123 6.22363C2.6123 6.19904 2.58558 6.19416 2.57227 6.21875C2.55895 6.26773 2.53244 6.24806 2.50586 6.24805C2.4393 6.24805 2.38589 6.25296 2.31934 6.24805C2.29276 6.24797 2.26584 6.22369 2.23926 6.21387C2.2128 6.20437 2.18662 6.23784 2.16016 6.18945C2.15963 6.19918 2.13336 6.2134 2.13281 6.20898C2.1196 6.20828 2.10599 6.16016 2.09277 6.17969C2.07969 6.21772 2.06679 6.18033 2.05371 6.16992C2.01379 6.16009 2.00001 6.05644 2 5.93848V5.85938C2.02657 5.72686 2.02687 5.73639 2.08008 5.72656C2.14652 5.71695 2.20013 5.79116 2.2666 5.7666C2.30638 5.83467 2.34597 5.79117 2.38574 5.80566C2.42568 5.82042 2.4796 5.8743 2.51953 5.83496C2.55929 5.79599 2.59891 5.80562 2.63867 5.80566C2.66529 5.80566 2.7058 5.83493 2.73242 5.83984C2.759 5.8446 2.79867 5.83015 2.8252 5.84473C2.85182 5.85456 2.86498 5.89861 2.8916 5.87402C2.93151 5.82012 2.97182 5.86445 3.01172 5.83496C3.06489 5.79575 3.13138 5.82034 3.18457 5.7959C3.21119 5.78115 3.23839 5.7666 3.27832 5.7666C3.29148 5.7666 3.30422 5.76671 3.31738 5.79102C3.33067 5.81555 3.35775 5.82032 3.37109 5.78125C3.37109 5.7665 3.39746 5.75185 3.39746 5.7666C3.42403 5.82038 3.45097 5.80082 3.47754 5.7959C3.49085 5.7959 3.51794 5.84487 3.53125 5.8252C3.54455 5.79107 3.57067 5.80559 3.58398 5.80078C3.58398 5.80078 3.61071 5.78094 3.62402 5.83008C3.62402 5.84483 3.6377 5.8448 3.6377 5.83496C3.65102 5.77126 3.6775 5.80569 3.7041 5.80078H3.86328C3.90321 5.80078 3.94383 5.73713 3.99707 5.76172C4.02357 5.69808 4.04967 5.72629 4.07617 5.72656C4.10279 5.72656 4.11693 5.75188 4.14355 5.76172C4.16982 5.77122 4.18352 5.76171 4.20996 5.79102C4.23657 5.82494 4.27619 5.79101 4.30273 5.80078C4.31605 5.80078 4.34313 5.77107 4.35645 5.83008C4.38304 5.76636 4.40955 5.78598 4.42285 5.81055C4.44941 5.84957 4.48904 5.83019 4.51562 5.83984C4.54225 5.84476 4.56908 5.83984 4.5957 5.83984C4.60896 5.83983 4.63508 5.83038 4.64844 5.85938C4.66175 5.87905 4.68884 5.84476 4.70215 5.83984H4.92871C4.95518 5.84486 4.96857 5.86912 4.99512 5.87402C5.04832 5.88381 5.10148 5.81538 5.16797 5.83984C5.18125 5.79577 5.19472 5.82508 5.20801 5.83984C5.22132 5.84968 5.2351 5.86949 5.26172 5.82031C5.26172 5.80562 5.26126 5.81049 5.27441 5.80566C5.28771 5.80075 5.30116 5.8448 5.31445 5.80566C5.31445 5.78108 5.34118 5.8057 5.35449 5.80078C5.36778 5.79592 5.39442 5.82996 5.39453 5.77148C5.42111 5.85431 5.44803 5.72732 5.47461 5.7666C5.47485 5.78095 5.48779 5.78127 5.50098 5.79102C5.50104 5.79285 5.50179 5.80485 5.51367 5.80078C5.58023 5.7221 5.66098 5.78631 5.72754 5.76172C5.72754 5.76172 5.7406 5.74128 5.75391 5.73145C5.75423 5.73042 5.75603 5.72764 5.7666 5.73145C5.78564 5.74552 5.79612 5.75228 5.80566 5.75293C5.8062 5.73113 5.80566 5.7093 5.80566 5.6875C5.80691 5.68632 5.81962 5.67281 5.80566 5.66016C5.74173 5.64685 5.70239 5.62073 5.80566 5.60742C5.73682 5.59411 5.77051 5.56702 5.77051 5.55371C5.78004 5.48726 5.70199 5.42056 5.73145 5.34082C5.73014 5.33832 5.71789 5.31341 5.74121 5.30078C5.78533 5.28748 5.71178 5.27441 5.73145 5.27441C5.74614 5.27438 5.71667 5.24768 5.73633 5.23438C5.80509 5.20775 5.78532 5.16821 5.76074 5.1416C5.74107 5.11498 5.71662 5.08815 5.74121 5.06152C5.76336 5.03488 5.76929 5.01159 5.77051 4.98828V4.76855C5.77061 4.74204 5.79522 4.72872 5.73633 4.70215C5.7265 4.70215 5.73141 4.70178 5.73633 4.68848C5.74628 4.67524 5.77051 4.66167 5.77051 4.64844C5.76992 4.63537 5.74616 4.62244 5.73633 4.60938C5.72654 4.60936 5.73619 4.58268 5.70703 4.56934C5.68246 4.56934 5.70686 4.54262 5.73633 4.5293C5.80026 4.50267 5.86436 4.46217 5.84961 4.43555C5.83996 4.40893 5.84961 4.3693 5.84961 4.34277C5.84961 4.3295 5.84956 4.31601 5.8252 4.30273C5.80062 4.30273 5.81045 4.26333 5.8252 4.25C5.85461 4.22346 5.85928 4.19646 5.8252 4.16992C5.81064 4.16992 5.81514 4.15668 5.81055 4.14355V3.9502C5.81356 3.94349 5.82242 3.9364 5.84473 3.92969C5.79097 3.92969 5.81036 3.90402 5.81543 3.89062C5.82035 3.87731 5.84469 3.85023 5.84961 3.83691C5.8545 3.81041 5.84956 3.79695 5.82031 3.77051C5.79081 3.74389 5.83918 3.73072 5.79492 3.7041C5.78642 3.7041 5.81543 3.70354 5.81543 3.69043C5.80559 3.66381 5.85404 3.63697 5.78027 3.61035C5.8539 3.58378 5.80003 3.55782 5.78027 3.53125C5.7606 3.50463 5.82031 3.46412 5.82031 3.4375C5.82027 3.39762 5.79575 3.37095 5.82031 3.33105C5.86918 3.27789 5.84475 3.21136 5.84961 3.1582C5.85452 3.10507 5.84963 3.03854 5.84961 2.98535C5.84961 2.95879 5.82045 2.93183 5.81543 2.90527V2.74512C5.81513 2.74471 5.79593 2.71829 5.83984 2.70508H5.84473C5.79557 2.67846 5.80047 2.66529 5.84473 2.63867C5.85914 2.63855 5.84471 2.62555 5.84961 2.6123C5.86905 2.58584 5.82545 2.57229 5.81055 2.5459C5.79579 2.53259 5.84424 2.5055 5.77539 2.49219C5.76592 2.49219 5.76589 2.49235 5.77539 2.47949C5.8885 2.43956 5.70239 2.39931 5.80566 2.35938C5.74195 2.34611 5.81491 2.3326 5.80566 2.31934C5.79098 2.30609 5.77553 2.29297 5.77539 2.2666V2.16602C5.77532 2.14952 5.77044 2.13332 5.74609 2.12012C5.72651 2.12005 5.71681 2.0934 5.77051 2.08008H5.77539C5.75574 2.05348 5.81001 2.00009 5.9082 2H6.09082Z" fill="currentColor"/></svg>`;
var ICON_MINUS = `<svg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'><path d="M5.95312 5.70228C5.97975 5.66785 6.00658 5.73238 6.0332 5.75696C6.05977 5.78152 6.08671 5.8107 6.11328 5.80579C6.17969 5.8009 6.24609 5.80578 6.3125 5.80579C6.3125 5.80579 6.32653 5.82055 6.33984 5.80579C6.35316 5.74188 6.37927 5.70254 6.39258 5.80579C6.40589 5.73694 6.43298 5.77161 6.44629 5.77161C6.51271 5.78108 6.57947 5.70213 6.65918 5.73157C6.66246 5.7299 6.68681 5.71874 6.69922 5.74134C6.71244 5.78529 6.7254 5.71333 6.72559 5.73157C6.72559 5.74628 6.75227 5.71716 6.76562 5.73646C6.79216 5.80507 6.83178 5.78632 6.8584 5.76185C6.88495 5.74223 6.91192 5.71708 6.93848 5.74134C6.96513 5.7635 6.9884 5.77039 7.01172 5.77161H7.23145C7.25796 5.77171 7.27128 5.79535 7.29785 5.73646C7.29785 5.72721 7.29841 5.73161 7.31152 5.73646C7.32482 5.74631 7.33826 5.77161 7.35156 5.77161C7.3647 5.77105 7.37748 5.7462 7.39062 5.73646C7.39136 5.72729 7.41754 5.73625 7.43066 5.70716C7.43083 5.68306 7.45737 5.70723 7.4707 5.73646C7.49733 5.80039 7.53783 5.86449 7.56445 5.84974C7.59107 5.84017 7.63075 5.84973 7.65723 5.84974C7.67054 5.84974 7.68395 5.84991 7.69727 5.82532C7.69736 5.80099 7.73648 5.81073 7.75 5.82532C7.77661 5.85482 7.80347 5.8597 7.83008 5.82532C7.83013 5.81083 7.8433 5.81533 7.85645 5.81067H8.03027C8.04347 5.81052 8.05712 5.80106 8.07031 5.84485C8.07039 5.79157 8.09596 5.81042 8.10938 5.81556C8.12266 5.82047 8.14975 5.84476 8.16309 5.84974C8.1897 5.85465 8.20289 5.84992 8.22949 5.82044C8.25607 5.79098 8.26936 5.83992 8.2959 5.79603C8.2959 5.78619 8.29626 5.81556 8.30957 5.81556C8.33615 5.80586 8.36307 5.85492 8.38965 5.78138C8.4161 5.85433 8.4423 5.80127 8.46875 5.78138C8.49537 5.76171 8.53588 5.82044 8.5625 5.82044C8.60238 5.8204 8.62905 5.79587 8.66895 5.82044C8.72214 5.86956 8.78858 5.84488 8.8418 5.84974C8.89493 5.85464 8.96146 5.84976 9.01465 5.84974C9.04123 5.84974 9.06814 5.82054 9.09473 5.81556H9.25488C9.25743 5.81382 9.28231 5.79812 9.29492 5.83997V5.84485C9.32141 5.79607 9.33479 5.80075 9.36133 5.84485C9.36133 5.85958 9.37441 5.8449 9.3877 5.84974C9.41428 5.86938 9.42756 5.82549 9.4541 5.81067C9.4674 5.79594 9.49449 5.84506 9.50781 5.7765C9.50781 5.76668 9.50726 5.76671 9.52051 5.7765C9.56042 5.88931 9.60071 5.70256 9.64062 5.80579C9.65394 5.74186 9.66735 5.81563 9.68066 5.80579C9.6939 5.79112 9.70705 5.77663 9.7334 5.7765H9.83398C9.85039 5.77642 9.86672 5.77118 9.87988 5.7472C9.87988 5.72753 9.90661 5.71752 9.91992 5.77161V5.7765C9.94654 5.75682 10 5.81095 10 5.90931V6.09095C10 6.12045 9.98694 6.1357 9.97363 6.16028C9.96036 6.19469 9.94646 6.24323 9.91992 6.25794C9.89332 6.27758 9.88013 6.25794 9.85352 6.25794L9.93359 6.22376C9.89376 6.25319 9.84068 6.17048 9.80078 6.1847C9.74767 6.19941 9.70734 6.18963 9.6543 6.1847C9.62767 6.1847 9.60023 6.19429 9.58691 6.21888C9.5604 6.24285 9.53379 6.18958 9.52051 6.25794C9.46731 6.25805 9.4008 6.28742 9.34766 6.25306C9.28127 6.21391 9.21483 6.23835 9.14844 6.22376C9.04212 6.30232 8.93542 6.24344 8.8291 6.25794C8.80248 6.25794 8.76161 6.27782 8.72168 6.22864C8.69508 6.18985 8.65548 6.26285 8.62891 6.18958V6.20423C8.62863 6.21405 8.6026 6.22861 8.60254 6.22376C8.53605 6.18446 8.53591 6.18454 8.49609 6.22376C8.49609 6.22376 8.48206 6.19935 8.46875 6.19935C8.44235 6.19923 8.41605 6.18969 8.38965 6.19935C8.36304 6.20426 8.33618 6.16479 8.30957 6.23353C8.30957 6.24815 8.2964 6.23377 8.2832 6.23353H8.20312C8.17652 6.23844 8.136 6.20881 8.10938 6.26771C8.10938 6.29209 8.08373 6.22988 8.07031 6.23841C8.05706 6.26288 8.04352 6.27246 8.03027 6.26771C8.01702 6.26771 8.00349 6.23863 7.99023 6.23353C7.99023 6.23353 7.96357 6.26257 7.9502 6.26771C7.92358 6.27262 7.88307 6.24306 7.85645 6.27747C7.8299 6.3118 7.80389 6.30292 7.77734 6.30775H7.68359C7.65719 6.31236 7.6437 6.2824 7.61719 6.26771C7.59071 6.25334 7.57733 6.30219 7.55078 6.23353C7.51096 6.22372 7.45786 6.20434 7.41797 6.19935C7.3381 6.19443 7.2576 6.19935 7.17773 6.19935C7.15136 6.19953 7.13776 6.22357 7.11133 6.16517C7.11133 6.1558 7.09979 6.16815 7.09863 6.16517C7.07205 6.13571 7.05821 6.23818 7.04492 6.18958C7.03161 6.14532 7.00452 6.17008 6.99121 6.16517C6.96484 6.16037 6.9513 6.16517 6.9248 6.16517C6.9116 6.16525 6.89797 6.17008 6.88477 6.20423C6.87145 6.1403 6.84534 6.18393 6.83203 6.15442C6.83161 6.13499 6.80524 6.1158 6.79199 6.13978C6.76539 6.18892 6.75217 6.16518 6.72559 6.17005C6.69896 6.17987 6.65845 6.15506 6.63184 6.20423C6.6317 6.22352 6.60616 6.21395 6.59277 6.20423C6.5796 6.19936 6.56591 6.17532 6.55273 6.17005C6.52611 6.16513 6.49928 6.16984 6.47266 6.19935C6.44607 6.22872 6.41956 6.16981 6.40625 6.23841C6.40625 6.24824 6.40589 6.24333 6.39258 6.23841C6.36603 6.20899 6.35274 6.19431 6.32617 6.23353C6.29955 6.26303 6.27272 6.23841 6.24609 6.23841C6.21953 6.23847 6.19258 6.25313 6.16602 6.23841C6.15281 6.23011 6.13919 6.31651 6.12598 6.26282C6.12581 6.23369 6.09977 6.24816 6.07324 6.24817C6.05993 6.24817 6.03284 6.25801 6.01953 6.24817C5.93973 6.17487 5.84636 6.23855 5.7666 6.214C5.72691 6.20463 5.69993 6.25809 5.66016 6.17982C5.63364 6.23808 5.60757 6.18973 5.58105 6.22864C5.56783 6.25308 5.55424 6.25306 5.54102 6.25306H5.26172C5.20847 6.25306 5.14114 6.2774 5.08789 6.28724C5.07468 6.28738 5.06158 6.297 5.03516 6.25794C5.02185 6.2286 4.99476 6.22864 4.98145 6.27747V6.28724C4.94163 6.19949 4.91486 6.28721 4.875 6.29212C4.80859 6.29693 4.74219 6.24341 4.67578 6.25306C4.6625 6.25306 4.64902 6.2288 4.63574 6.28724C4.63566 6.23898 4.62255 6.26289 4.60938 6.28724C4.59606 6.31183 4.56898 6.31183 4.55566 6.28724C4.54246 6.2486 4.5292 6.26263 4.50293 6.25794H4.44922C4.3827 6.24811 4.30285 6.23362 4.23633 6.21888C4.22305 6.21888 4.20956 6.19459 4.19629 6.1847C4.18298 6.17486 4.16956 6.20364 4.15625 6.14954C4.15605 6.13066 4.14306 6.14944 4.12988 6.14954C4.08995 6.14954 4.06337 6.12094 4.02344 6.16028C3.99682 6.19916 3.95625 6.15015 3.92969 6.22376C3.92968 6.24319 3.90407 6.22418 3.89062 6.22376C3.85071 6.24342 3.79676 6.17939 3.75684 6.25794C3.74358 6.20936 3.71746 6.21883 3.7041 6.22376C3.69081 6.22376 3.67736 6.19925 3.66406 6.25306C3.65076 6.23829 3.63696 6.20417 3.61035 6.214C3.59712 6.22405 3.58355 6.25795 3.57031 6.25306C3.50406 6.2528 3.45103 6.18979 3.38477 6.214C3.37148 6.16981 3.34439 6.1798 3.33105 6.17493C3.29116 6.17499 3.26452 6.22872 3.22461 6.214C3.19804 6.20418 3.15846 6.18962 3.13184 6.214C3.07859 6.26317 3.02492 6.23346 2.97168 6.24329C2.95838 6.24333 2.94494 6.26308 2.93164 6.214C2.93164 6.19926 2.91857 6.20904 2.90527 6.22376C2.90527 6.25789 2.89211 6.23888 2.87891 6.24817C2.85229 6.28259 2.82484 6.14509 2.81152 6.24817H2.65234C2.65234 6.24817 2.62562 6.25817 2.6123 6.22376C2.6123 6.19917 2.58558 6.19429 2.57227 6.21888C2.55895 6.26794 2.53246 6.24819 2.50586 6.24817C2.4393 6.24817 2.38589 6.25309 2.31934 6.24817C2.29276 6.24809 2.26584 6.22381 2.23926 6.214C2.2128 6.20452 2.18662 6.23804 2.16016 6.18958C2.15974 6.19935 2.13316 6.2137 2.13281 6.20911C2.1196 6.2084 2.10599 6.16029 2.09277 6.17982C2.07967 6.21799 2.06681 6.18042 2.05371 6.17005C2.01379 6.16022 2.00001 6.05659 2 5.9386V5.8595C2.02656 5.72706 2.02688 5.73652 2.08008 5.72669C2.14651 5.71708 2.20013 5.79129 2.2666 5.76673C2.30638 5.83486 2.34597 5.79132 2.38574 5.80579C2.42568 5.82055 2.4796 5.87443 2.51953 5.83509C2.55928 5.79616 2.59892 5.80575 2.63867 5.80579C2.66529 5.80579 2.7058 5.83505 2.73242 5.83997C2.75899 5.84473 2.79866 5.83031 2.8252 5.84485C2.85182 5.85469 2.86498 5.89874 2.8916 5.87415C2.93149 5.82031 2.97183 5.86457 3.01172 5.83509C3.06489 5.79591 3.13139 5.82048 3.18457 5.79603C3.21119 5.78127 3.23839 5.76673 3.27832 5.76673C3.29147 5.76673 3.30423 5.76689 3.31738 5.79114C3.33067 5.81569 3.35776 5.82051 3.37109 5.78138C3.37109 5.76662 3.39746 5.75198 3.39746 5.76673C3.42405 5.82058 3.45095 5.80094 3.47754 5.79603C3.49085 5.79603 3.51794 5.84499 3.53125 5.82532C3.54457 5.79126 3.57068 5.80574 3.58398 5.80091C3.58398 5.80091 3.6107 5.78115 3.62402 5.83021C3.62402 5.84496 3.6377 5.84492 3.6377 5.83509C3.65102 5.77148 3.67751 5.80582 3.7041 5.80091H3.86328C3.90321 5.80091 3.94383 5.73726 3.99707 5.76185C4.02357 5.69821 4.04967 5.72642 4.07617 5.72669C4.10279 5.72669 4.11693 5.75201 4.14355 5.76185C4.16983 5.77136 4.18351 5.76183 4.20996 5.79114C4.23656 5.82513 4.27618 5.79117 4.30273 5.80091C4.31604 5.80091 4.34313 5.77124 4.35645 5.83021C4.38303 5.76656 4.40956 5.78612 4.42285 5.81067C4.4494 5.84975 4.48903 5.83034 4.51562 5.83997C4.54225 5.84489 4.56908 5.83997 4.5957 5.83997C4.60895 5.83996 4.63507 5.83058 4.64844 5.8595C4.66175 5.87917 4.68884 5.84489 4.70215 5.83997H4.92871C4.95519 5.84498 4.96857 5.86925 4.99512 5.87415C5.04832 5.88395 5.10149 5.81553 5.16797 5.83997C5.18124 5.79603 5.19474 5.8252 5.20801 5.83997C5.22132 5.84981 5.2351 5.86962 5.26172 5.82044C5.26172 5.8058 5.26125 5.81062 5.27441 5.80579C5.28772 5.80088 5.30115 5.84504 5.31445 5.80579C5.31445 5.7812 5.34118 5.80583 5.35449 5.80091C5.3678 5.79609 5.39444 5.83015 5.39453 5.77161C5.42112 5.85456 5.44802 5.72744 5.47461 5.76673C5.47481 5.78115 5.48777 5.78138 5.50098 5.79114C5.50102 5.79271 5.50161 5.80506 5.51367 5.80091C5.58023 5.72223 5.66098 5.78644 5.72754 5.76185C5.72754 5.76185 5.7406 5.74141 5.75391 5.73157C5.75429 5.73051 5.75627 5.72786 5.7666 5.73157C5.80654 5.76108 5.80675 5.76108 5.84668 5.73157C5.84704 5.7224 5.86089 5.73157 5.87402 5.73157C5.90046 5.72214 5.92669 5.73644 5.95312 5.70228Z" fill="currentColor"/></svg>`;

// src/sections/algolia-main-search/facets.ts
function isHiddenFacet(attribute) {
  const normalizedAttribute = attribute.trim();
  const localeKey = normalizedAttribute.split(".").pop() ?? normalizedAttribute;
  return ALGOLIA_HIDDEN_FACET_ATTRIBUTES.some(
    (hidden) => hidden === normalizedAttribute || hidden === localeKey
  );
}
function parsePairs(value) {
  return value.split(",").map((item) => item.trim()).filter(Boolean).map((entry) => {
    const colonIndex = entry.indexOf(":");
    if (colonIndex === -1) {
      return {
        value: entry,
        label: (entry.split(".").pop() ?? entry).replace(/_/g, " ")
      };
    }
    return {
      value: entry.slice(0, colonIndex).trim(),
      label: entry.slice(colonIndex + 1).trim()
    };
  });
}
function labelFromAttr(attribute) {
  return attribute.split(".").pop().replace(/_/g, " ").replace(/\b\w/g, (character) => character.toUpperCase());
}
function isPriceRangeFacet(attribute) {
  if (!attribute) return false;
  const normalizedAttribute = attribute.toLowerCase().replace(/_/g, "-");
  return normalizedAttribute.includes("price") && normalizedAttribute.includes("range");
}
function currencyCode() {
  return window.currencyIsoCode || window.Shopify?.currency?.active || "EUR";
}
function currencySymbol() {
  const currency = currencyCode();
  try {
    return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
      currency,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: "currency"
    }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency;
  } catch {
    return currency;
  }
}
function formatPriceRangeAmount(value) {
  const numericValue = Number(value.replace(",", "."));
  if (!Number.isFinite(numericValue)) return value;
  const amount = new Intl.NumberFormat(
    document.documentElement.lang || "fr-FR",
    {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0
    }
  ).format(numericValue);
  return `${amount}${currencySymbol()}`;
}
function formatPriceRangeValue(value) {
  const rawValue = String(value ?? "");
  const amounts = rawValue.match(/\d+(?:[.,]\d+)?/g);
  if (!amounts || amounts.length < 2) return rawValue;
  return `${formatPriceRangeAmount(amounts[0])} - ${formatPriceRangeAmount(
    amounts[1]
  )}`;
}
function priceRangeStart(value) {
  const rawValue = String(value ?? "");
  const amount = rawValue.match(/\d+(?:[.,]\d+)?/);
  if (!amount) return Number.POSITIVE_INFINITY;
  const numericValue = Number(amount[0].replace(",", "."));
  return Number.isFinite(numericValue) ? numericValue : Number.POSITIVE_INFINITY;
}
function formatTextFacetLabel(label) {
  const rawLabel = String(label ?? "").trim();
  if (!rawLabel) return "";
  const readableRawLabel = collapseRepeatedLabel(rawLabel);
  const readableLabel = readableRawLabel.replace(/[-_]+/g, " ");
  return readableLabel.charAt(0).toUpperCase() + readableLabel.slice(1);
}
function collapseRepeatedLabel(label) {
  const normalizedLabel = label.toLowerCase();
  for (let chunkLength = 1; chunkLength <= label.length / 2; chunkLength += 1) {
    if (label.length % chunkLength !== 0) continue;
    const normalizedChunk = normalizedLabel.slice(0, chunkLength);
    const repeatCount = label.length / chunkLength;
    let isRepeated = repeatCount > 1;
    for (let index = 1; index < repeatCount; index += 1) {
      const chunkStart = index * chunkLength;
      const chunkEnd = chunkStart + chunkLength;
      if (normalizedLabel.slice(chunkStart, chunkEnd) !== normalizedChunk) {
        isRepeated = false;
        break;
      }
    }
    if (isRepeated) return label.slice(0, chunkLength).trim();
  }
  return label;
}
function formatFacetLabel(attribute, label, value) {
  if (!isPriceRangeFacet(attribute)) return formatTextFacetLabel(label);
  return formatPriceRangeValue(value ?? label);
}
function formatFacetItems(attribute, items) {
  const formattedItems = items.map((item) => {
    const label = formatFacetLabel(attribute, item.label, item.value);
    return {
      ...item,
      highlighted: label,
      label
    };
  });
  if (!isPriceRangeFacet(attribute)) return formattedItems;
  return formattedItems.sort(
    (firstItem, secondItem) => priceRangeStart(firstItem.value ?? firstItem.label) - priceRangeStart(secondItem.value ?? secondItem.label)
  );
}
function escapeAttribute(value) {
  return value.replace(/&/g, "&amp;").replace(/'/g, "&#39;");
}
function buildFacetDetails(container, attribute, label, actionLabels) {
  const safeId = `ais-facet-${attribute.replace(/[^a-z0-9]/gi, "-")}`;
  container.innerHTML = `
    <details
      data-inputs-filter
      data-ais-facet
      data-ais-facet-attribute='${escapeAttribute(attribute)}'
    >
      <summary>
        <span>${label}</span>
        <div class='container-plus-minus'>
          <span class='plus'>${ICON_PLUS}</span>
          <span class='minus'>${ICON_MINUS}</span>
        </div>
      </summary>
      <div class='ais-facet-action'>
        <button
          type='button'
          class='link v-secondary m-0'
          data-ais-facet-toggle
          data-select-label='${actionLabels.select}'
          data-deselect-label='${actionLabels.deselect}'
        >
          <span class='cta--label'>
            <span class='cta--label__text' data-ais-facet-toggle-label>${actionLabels.select}</span>
          </span>
        </button>
      </div>
      <div id='${safeId}' class='ais-facet-container'></div>
    </details>`;
  return safeId;
}

// src/sections/algolia-main-search/load-script.ts
var pending = /* @__PURE__ */ new Map();
function loadScript(src, integrity) {
  const cached = pending.get(src);
  if (cached) return cached;
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.crossOrigin = "anonymous";
    if (integrity) script.integrity = integrity;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
  pending.set(src, promise);
  return promise;
}

// src/sections/algolia-main-search/insights.ts
var ALGOLIA_USER_TOKEN_KEY = "diptyque:algolia:user-token";
var PIXEL_CONFIG_KEY = "algolia_config";
var PIXEL_CLICKED_OBJECTS_KEY = "algolia_analytics_clicked_objects";
var MAX_PIXEL_CLICKED_OBJECTS = 40;
var ONE_TRUST_ANALYTICS_PATTERN = /perform|analyt|statis|mesure|audience/i;
var ONE_TRUST_ANALYTICS_GROUP_IDS = ["PERF", "C0002"];
var CONSENT_POLL_INTERVAL_MS = 250;
var CONSENT_POLL_ATTEMPTS = 60;
var initPromise = null;
var initKey = "";
var trackingAllowed = false;
var cachedUserToken = null;
var customerPrivacyPromise = null;
function loadCustomerPrivacy() {
  if (customerPrivacyPromise) return customerPrivacyPromise;
  customerPrivacyPromise = new Promise((resolve) => {
    const shopify = window.Shopify;
    if (shopify?.customerPrivacy) {
      resolve();
      return;
    }
    if (typeof shopify?.loadFeatures !== "function") {
      resolve();
      return;
    }
    const done = () => resolve();
    window.setTimeout(done, 3e3);
    try {
      shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        done
      );
    } catch {
      done();
    }
  });
  return customerPrivacyPromise;
}
function shopifyAnalyticsAllowed() {
  const customerPrivacy = window.Shopify?.customerPrivacy;
  if (typeof customerPrivacy?.analyticsProcessingAllowed !== "function") {
    return null;
  }
  try {
    return customerPrivacy.analyticsProcessingAllowed() === true;
  } catch {
    return null;
  }
}
function oneTrustConsentFromCookie() {
  const match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
  if (!match) return null;
  const groups = new URLSearchParams(match[1]).get("groups");
  if (!groups) return null;
  const granted = groups.split(",").map((pair) => pair.split(":")).filter(([, value]) => value?.trim() === "1").map(([id]) => id?.trim());
  return granted.some((id) => id && ONE_TRUST_ANALYTICS_GROUP_IDS.includes(id));
}
function oneTrustAnalyticsAllowedFromSdk() {
  const consentWindow = window;
  const active = consentWindow.OnetrustActiveGroups;
  if (typeof active !== "string" || !active) return null;
  const activeIds = active.split(",").map((id) => id.trim()).filter(Boolean);
  let groups = [];
  try {
    groups = consentWindow.OneTrust?.GetDomainData?.().Groups ?? [];
  } catch {
    groups = [];
  }
  const analyticsIds = groups.filter(
    (group) => ONE_TRUST_ANALYTICS_PATTERN.test(
      `${group.GroupName ?? ""} ${group.Type ?? ""}`
    )
  ).map((group) => group.CustomGroupId).filter((id) => Boolean(id));
  const ids = analyticsIds.length ? analyticsIds : ONE_TRUST_ANALYTICS_GROUP_IDS;
  return ids.some((id) => activeIds.includes(id)) ? true : null;
}
function oneTrustAnalyticsAllowed() {
  const cookie = oneTrustConsentFromCookie();
  const live = oneTrustAnalyticsAllowedFromSdk();
  if (cookie === true || live === true) return true;
  if (cookie === false || live === false) return false;
  return null;
}
async function resolveTrackingConsent() {
  await loadCustomerPrivacy();
  return shopifyAnalyticsAllowed() === true || oneTrustAnalyticsAllowed() === true;
}
var trackingEnabledCallbacks = [];
function flushTrackingEnabledCallbacks() {
  const callbacks = trackingEnabledCallbacks.splice(0);
  callbacks.forEach((callback) => callback());
}
var consentWatcherStarted = false;
function watchConsentChanges(appId, apiKey, indexName) {
  if (consentWatcherStarted) return;
  consentWatcherStarted = true;
  const reinit = () => {
    if (trackingAllowed) return;
    initPromise = null;
    initKey = "";
    void initAlgoliaInsights(appId, apiKey, indexName);
  };
  document.addEventListener("visitorConsentCollected", reinit);
  window.addEventListener("OneTrustGroupsUpdated", reinit);
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (trackingAllowed || attempts > CONSENT_POLL_ATTEMPTS) {
      window.clearInterval(timer);
      return;
    }
    if (oneTrustAnalyticsAllowed() === true || shopifyAnalyticsAllowed() === true) {
      window.clearInterval(timer);
      reinit();
    }
  }, CONSENT_POLL_INTERVAL_MS);
}
function createToken() {
  if ("crypto" in window && "randomUUID" in window.crypto) {
    return window.crypto.randomUUID();
  }
  return `anonymous-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
function getAlgoliaUserToken() {
  if (!trackingAllowed) {
    cachedUserToken ?? (cachedUserToken = createToken());
    return cachedUserToken;
  }
  try {
    const storedToken = window.localStorage.getItem(ALGOLIA_USER_TOKEN_KEY);
    if (storedToken) {
      cachedUserToken = storedToken;
      return storedToken;
    }
    const nextToken = cachedUserToken ?? createToken();
    window.localStorage.setItem(ALGOLIA_USER_TOKEN_KEY, nextToken);
    cachedUserToken = nextToken;
    return nextToken;
  } catch {
    cachedUserToken ?? (cachedUserToken = createToken());
    return cachedUserToken;
  }
}
function installInsightsQueue() {
  const insightsWindow = window;
  if (typeof insightsWindow.aa === "function") return insightsWindow.aa;
  const queued = [];
  const aa = ((...args) => {
    queued.push(args);
  });
  aa.queue = queued;
  insightsWindow.AlgoliaAnalyticsObject = "aa";
  insightsWindow.aa = aa;
  return aa;
}
async function initAlgoliaInsights(appId, apiKey, indexName) {
  const key = `${appId}:${apiKey}`;
  if (initPromise && initKey === key) return initPromise;
  initKey = key;
  initPromise = (async () => {
    trackingAllowed = await resolveTrackingConsent();
    if (!trackingAllowed) {
      watchConsentChanges(appId, apiKey, indexName);
      return null;
    }
    const aa = installInsightsQueue();
    const userToken = getAlgoliaUserToken();
    aa("init", { appId, apiKey, userToken, useCookie: false });
    writePixelConfig({ appId, apiKey, indexName, userToken });
    try {
      await loadScript(CDN_SEARCH_INSIGHTS, SRI_SEARCH_INSIGHTS);
    } catch (error) {
      console.warn("Algolia Insights could not be loaded", error);
      return null;
    }
    flushTrackingEnabledCallbacks();
    return aa;
  })();
  return initPromise;
}
function sendAlgoliaEvent(method, payload) {
  if (!trackingAllowed) return false;
  const aa = window.aa;
  if (!aa || !payload.index || payload.objectIDs.length === 0) return false;
  aa(method, payload);
  return true;
}
function writePixelConfig({
  appId,
  apiKey,
  indexName,
  userToken
}) {
  if (!trackingAllowed || !indexName) return;
  try {
    window.localStorage.setItem(
      PIXEL_CONFIG_KEY,
      JSON.stringify({
        app_id: appId,
        search_api_key: apiKey,
        index_name: indexName,
        user_token: userToken
      })
    );
  } catch {
    return;
  }
}
function recordClickForPixel(analytics) {
  if (!trackingAllowed || !analytics.queryID) return;
  try {
    const stored = window.localStorage.getItem(PIXEL_CLICKED_OBJECTS_KEY);
    const previous = stored ? JSON.parse(stored) : [];
    const others = previous.filter(
      (record) => !record.objectIDs?.includes(
        analytics.objectID
      )
    );
    others.push({
      index: analytics.index,
      objectIDs: [analytics.objectID],
      queryID: analytics.queryID,
      ...analytics.position ? { positions: [analytics.position] } : {},
      ...analytics.productID ? { productId: analytics.productID } : {}
    });
    window.localStorage.setItem(
      PIXEL_CLICKED_OBJECTS_KEY,
      JSON.stringify(others.slice(-MAX_PIXEL_CLICKED_OBJECTS))
    );
  } catch {
    return;
  }
}
function readProductAnalytics(element) {
  const productEl = element.closest("[data-algolia-product]");
  if (!productEl) return null;
  const index = productEl.dataset.algoliaIndex;
  const objectID = productEl.dataset.algoliaObjectId;
  if (!index || !objectID) return null;
  const queryID = productEl.dataset.algoliaQueryId;
  const position = Number(productEl.dataset.algoliaPosition);
  return {
    index,
    objectID,
    productID: productEl.dataset.algoliaProductId,
    position: Number.isFinite(position) && position > 0 ? position : void 0,
    queryID
  };
}
function sendAlgoliaClickEvent(element) {
  const analytics = readProductAnalytics(element);
  if (!analytics) return;
  recordClickForPixel(analytics);
  if (analytics.queryID && analytics.position) {
    sendAlgoliaEvent("clickedObjectIDsAfterSearch", {
      eventName: "Product Clicked",
      index: analytics.index,
      objectIDs: [analytics.objectID],
      positions: [analytics.position],
      queryID: analytics.queryID
    });
    return;
  }
  sendAlgoliaEvent("clickedObjectIDs", {
    eventName: "Product Clicked",
    index: analytics.index,
    objectIDs: [analytics.objectID]
  });
}
function trackAlgoliaAddToCart(element) {
  const analytics = readProductAnalytics(element);
  if (!analytics) return;
  recordClickForPixel(analytics);
}

// src/sections/algolia-main-search/product-card.ts
var cardIndex = 0;
var DEFAULT_CARD_ASSETS = {
  alertIcon: "",
  notifyMeLabel: "",
  quickBuyIcon: "",
  quickBuyLabel: "",
  setToComposeLabel: "",
  contenanceLabel: "Contenance",
  modelsLabelOne: "+{{ count }} model",
  modelsLabelOther: "+{{ count }} models"
};
var PREFIXED_CURRENCY_SYMBOLS = {
  JPY: "\xA5",
  GBP: "\xA3"
};
function escapeHtml(value) {
  return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function escapeAttribute2(value) {
  return escapeHtml(value);
}
function renderAnalyticsAttributes(hit, analytics) {
  const objectID = hit.objectID;
  if (!analytics?.indexName || objectID == null) return "";
  const attrs = [
    `data-algolia-product`,
    `data-algolia-index='${escapeAttribute2(analytics.indexName)}'`,
    `data-algolia-object-id='${escapeAttribute2(objectID)}'`
  ];
  if (hit.id != null) {
    attrs.push(`data-algolia-product-id='${escapeAttribute2(hit.id)}'`);
  }
  if (analytics.queryID) {
    attrs.push(`data-algolia-query-id='${escapeAttribute2(analytics.queryID)}'`);
  }
  if (analytics.position) {
    attrs.push(`data-algolia-position='${escapeAttribute2(analytics.position)}'`);
  }
  return attrs.join(" ");
}
function formatPrice(price) {
  if (price == null) return "";
  try {
    const numericPrice = typeof price === "number" ? price : Number(price);
    const currency = window.currencyIsoCode || window.Shopify?.currency?.active || "EUR";
    const amount = new Intl.NumberFormat(
      document.documentElement.lang || "fr-FR",
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }
    ).format(numericPrice);
    const moneyFormat = window.algoliaMoneyFormat;
    if (moneyFormat && moneyFormat.includes("0")) {
      return moneyFormat.replace("0", amount);
    }
    const currencySymbol2 = new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency;
    if (currencySymbol2.includes("$")) {
      const currencyPrefix = currency.slice(0, 2);
      return currencyPrefix === "HK" ? `HK$${amount}` : `${currencyPrefix} $${amount}`;
    }
    const prefixedSymbol = PREFIXED_CURRENCY_SYMBOLS[currency];
    if (prefixedSymbol) {
      return `${prefixedSymbol}${amount}`;
    }
    return `${amount} ${currencySymbol2}`;
  } catch {
    return String(price);
  }
}
function numericPriceValue(price) {
  if (price == null) return null;
  if (typeof price === "string" && price.trim() === "") return null;
  const numericPrice = typeof price === "number" ? price : Number(price);
  return Number.isFinite(numericPrice) ? numericPrice : null;
}
function itemUrl(hit) {
  if (hit.url) return hit.url;
  if (!hit.handle) return "#";
  const root = window.Shopify?.routes?.root ?? "/";
  const isCollection = [
    hit.type,
    hit.object_type,
    String(hit.objectID ?? "").includes("/Collection/") ? "collection" : ""
  ].includes("collection");
  return `${root}${isCollection ? "collections" : "products"}/${hit.handle}`;
}
function parseMediaTags(hit) {
  if (!hit.meta?.custom?.media_tags) return [];
  try {
    return JSON.parse(hit.meta.custom.media_tags);
  } catch {
    return [];
  }
}
function renderImage(hit) {
  const mainImage = hit.image ? `<figure><img src='${escapeAttribute2(hit.image)}' alt='${escapeAttribute2(hit.title)}' loading='lazy' width='600' height='800'></figure>` : "<figure></figure>";
  const hoverEntry = parseMediaTags(hit).find(
    (media) => Array.isArray(media.tags) && media.tags.includes("Hover")
  );
  const hoverUrl = hoverEntry?.src ?? hoverEntry?.url ?? hoverEntry?.image_url ?? (typeof hoverEntry?.image === "string" && hoverEntry.image.startsWith("http") ? hoverEntry.image : null);
  const hoverImage = hoverUrl ? `<figure><img src='${escapeAttribute2(hoverUrl)}' alt='' loading='lazy' width='600' height='800'></figure>` : "";
  return {
    className: hoverUrl ? " is-hover-active" : "",
    html: `${mainImage}${hoverImage}`
  };
}
function renderAddonTags(tags = []) {
  const tagLabels = tags.map((tag) => tag.fields?.name).filter((name) => Boolean(name));
  if (tagLabels.length === 0) return "";
  return `<div class='card-product_tags'>
    ${tagLabels.map((name) => `<span class='tag label-s-regular'>${escapeHtml(name)}</span>`).join("")}
  </div>`;
}
function countRelatedProducts(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === "object" && value !== null && "value" in value) {
    return countRelatedProducts(value.value);
  }
  if (typeof value !== "string") return 0;
  const normalizedValue = value.trim();
  if (!normalizedValue) return 0;
  try {
    return countRelatedProducts(JSON.parse(normalizedValue));
  } catch {
    return normalizedValue.includes(",") ? normalizedValue.split(",").length : 1;
  }
}
var COUNT_PLACEHOLDER = /\{\{\s*count\s*\}\}|\{count\}/g;
function formatModelsLabel(count, assets) {
  const template = (count === 1 ? assets.modelsLabelOne : assets.modelsLabelOther).trim();
  if (!template) return "";
  COUNT_PLACEHOLDER.lastIndex = 0;
  if (COUNT_PLACEHOLDER.test(template)) {
    COUNT_PLACEHOLDER.lastIndex = 0;
    return template.replace(COUNT_PLACEHOLDER, String(count));
  }
  return `+${count} ${template}`;
}
function renderOtherModels(hit, assets) {
  const relatedProductsCount = countRelatedProducts(
    hit.meta?.custom?.related_products ?? hit.related_products
  );
  const otherModelsCount = relatedProductsCount - 1;
  if (otherModelsCount <= 0) return "";
  return `<span class='label-s-regular color-secondary'>${escapeHtml(formatModelsLabel(otherModelsCount, assets))}</span>`;
}
function metaobjectValue(value) {
  if (typeof value === "object" && value !== null) {
    const fieldValue = value.fields?.value;
    if (typeof fieldValue === "string") return fieldValue.trim();
  }
  return "";
}
function renderProductInfo(hit, assets) {
  const label = metaobjectValue(hit.meta?.custom?.format) || (hit.meta?.custom?.label ?? "");
  const contenance = metaobjectValue(hit.meta?.custom?.capacity) || (hit.meta?.custom?.contenance ?? "");
  const otherModels = renderOtherModels(hit, assets);
  if (!label && !contenance && !otherModels) return "";
  return `<div>
    ${label ? `<span class='label-s-regular'>${escapeHtml(label)}</span>` : ""}
    ${label && contenance ? `<span class='label-s-regular'>-</span>` : ""}
    ${contenance ? `<span class='label-s-regular'>${escapeHtml(contenance)}</span>` : ""}
    ${otherModels}
  </div>`;
}
function renderSubtitle(hit) {
  const subtitle = hit.meta?.custom?.subtitle ?? hit.subtitle ?? "";
  if (!subtitle) return "";
  return `<p class='card-product_description body-m-light color-secondary'>${escapeHtml(subtitle)}</p>`;
}
function isSetToComposeProduct(hit) {
  if (String(hit.template_suffix ?? "").trim() === "set-to-compose") {
    return true;
  }
  const bundle = hit.meta?.bundle;
  if (!bundle) return false;
  const pricingMode = String(bundle.pricing_mode ?? "").trim();
  const bundleSize = Number(bundle.size);
  return Boolean(pricingMode) || Number.isFinite(bundleSize) && bundleSize > 0;
}
function parseBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return null;
  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "true") return true;
  if (normalizedValue === "false") return false;
  return null;
}
function parseJsonValue(value) {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
function nestedValue(value) {
  if (typeof value === "object" && value !== null && "value" in value) {
    return nestedValue(value.value);
  }
  return value;
}
function allowedProductsFrom(value) {
  const normalizedValue = nestedValue(value);
  if (Array.isArray(normalizedValue)) return normalizedValue;
  if (typeof normalizedValue !== "string") return [];
  const parsedValue = parseJsonValue(normalizedValue.trim());
  return Array.isArray(parsedValue) ? parsedValue : [];
}
function normalizeBundlePrice(value) {
  if (!Number.isFinite(value) || value <= 0) return null;
  return Number.isInteger(value) && value >= 1e3 ? value / 100 : value;
}
function priceFromAllowedProduct(value) {
  const normalizedValue = nestedValue(value);
  if (typeof normalizedValue === "number") {
    return normalizeBundlePrice(normalizedValue);
  }
  if (typeof normalizedValue === "string") {
    const parsedNumber = Number(normalizedValue);
    if (Number.isFinite(parsedNumber)) return normalizeBundlePrice(parsedNumber);
    const parsedValue = parseJsonValue(normalizedValue);
    if (parsedValue !== normalizedValue)
      return priceFromAllowedProduct(parsedValue);
    return null;
  }
  if (typeof normalizedValue !== "object" || normalizedValue === null) {
    return null;
  }
  const product = normalizedValue;
  const directPrice = priceFromAllowedProduct(
    product.price ?? product.variant_price ?? product.selected_or_first_available_variant_price
  );
  if (directPrice != null) return directPrice;
  return priceFromAllowedProduct(
    product.selected_or_first_available_variant?.price ?? product.variant?.price ?? product.product?.selected_or_first_available_variant
  );
}
function dynamicBundleLowestPrice(hit) {
  const bundle = hit.meta?.bundle;
  if (!bundle) return null;
  const pricingMode = String(bundle.pricing_mode ?? "").trim().toLowerCase();
  const bundleSize = Number(bundle.size);
  if (pricingMode !== "dynamic" || !Number.isFinite(bundleSize) || bundleSize <= 0) {
    return null;
  }
  const allowedPrices = allowedProductsFrom(bundle.allowed_products).map(priceFromAllowedProduct).filter((price) => price != null).sort((firstPrice, secondPrice) => firstPrice - secondPrice);
  if (allowedPrices.length === 0) return null;
  const allowDuplicates = parseBoolean(bundle.allow_duplicates);
  if (allowDuplicates === false) {
    const selectedPrices = allowedPrices.slice(0, bundleSize);
    if (selectedPrices.length < bundleSize) return null;
    return selectedPrices.reduce((total, price) => total + price, 0);
  }
  return allowedPrices[0] * bundleSize;
}
function marketPricingKey() {
  const currency = window.Shopify?.currency?.active?.toLowerCase();
  return currency ? `market_pricing_${currency}` : null;
}
function productAttributesToRetrieve(base = ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE) {
  const key = marketPricingKey();
  return key ? [...base, key] : base;
}
function getMarketPrice(hit) {
  const key = marketPricingKey();
  const marketPrice = key ? numericPriceValue(
    hit[key]?.price
  ) : null;
  return marketPrice != null && marketPrice > 0 ? marketPrice : hit.price;
}
function renderProductPrice(hit) {
  if (isSetToComposeProduct(hit) && numericPriceValue(hit.price) === 0) {
    return "";
  }
  const bundlePrice = dynamicBundleLowestPrice(hit);
  if (bundlePrice != null) return formatPrice(bundlePrice);
  const price = getMarketPrice(hit);
  return price != 0 ? formatPrice(price) : "";
}
function renderQuickBuyContent(label, icon) {
  return `<span class='card-product-quick-buy__content'>
    <span class='logo' aria-hidden='true'>${icon}</span>
    <span class='label label-s-regular'>${escapeHtml(label)}</span>
  </span>`;
}
function renderQuickBuyButton(hit, url, formId, assets) {
  const available = !Object.is(hit.inventory_available, false);
  const isSetToCompose = isSetToComposeProduct(hit);
  if (!available) {
    const notifyUrl = url.includes("#notify-me") ? url : `${url}#notify-me`;
    return `<a
      class='card-product-quick-buy'
      data-notify-me-button
      href='${escapeAttribute2(notifyUrl)}'
    >
      ${renderQuickBuyContent(assets.notifyMeLabel, assets.alertIcon)}
    </a>`;
  }
  if (isSetToCompose) {
    return `<a
      class='card-product-quick-buy'
      href='${escapeAttribute2(url)}'
    >
      ${renderQuickBuyContent(assets.setToComposeLabel, assets.quickBuyIcon)}
    </a>`;
  }
  return `<button
    type='submit'
    form='${escapeAttribute2(formId)}'
    class='card-product-quick-buy'
    data-algolia-convert
  >
    ${renderQuickBuyContent(assets.quickBuyLabel, assets.quickBuyIcon)}
  </button>`;
}
function giftProductIdFromGid(gid) {
  const match = /\/Product\/(\d+)/.exec(gid);
  return match ? match[1] : null;
}
function giftFromHit(hit) {
  const gift = hit.meta?.custom?.gift_product;
  if (!gift) return null;
  if (typeof gift === "string") {
    const productId = giftProductIdFromGid(gift);
    return productId ? { productId } : null;
  }
  if (typeof gift === "object") {
    if (gift.variant_id != null && gift.variant_id !== "") {
      return { variantId: gift.variant_id, available: gift.available !== false };
    }
    const productId = gift.id ? giftProductIdFromGid(gift.id) : null;
    return productId ? { productId } : null;
  }
  return null;
}
function isGiftEligible(hit) {
  return !isSetToComposeProduct(hit) && !Object.is(hit.inventory_available, false);
}
function renderGiftLineItemInputs(giftVariantId, parentVariantId) {
  return `
    <input type='hidden' name='items[0][properties][_child]' value='${escapeAttribute2(giftVariantId)}'>
    <input type='hidden' name='items[1][id]' value='${escapeAttribute2(giftVariantId)}'>
    <input type='hidden' name='items[1][parent_id]' value='${escapeAttribute2(parentVariantId)}'>
    <input type='hidden' name='items[1][quantity]' value='1'>
    <input type='hidden' name='items[1][properties][_gift_product]' value='true'>
    <input type='hidden' name='items[1][properties][_parent_id]' value='${escapeAttribute2(parentVariantId)}'>`;
}
function contenanceOf(hit) {
  const capacity = metaobjectValue(hit.meta?.custom?.capacity);
  if (capacity) return capacity;
  const custom = hit.meta?.custom?.contenance;
  if (typeof custom === "string" && custom) return custom;
  return typeof hit.contenance === "string" ? hit.contenance : "";
}
function renderAddToCartInputs(hit, variantId, contenanceLabel) {
  const contenance = contenanceOf(hit);
  const gift = isGiftEligible(hit) ? giftFromHit(hit) : null;
  const giftInputs = gift && "variantId" in gift && gift.available ? renderGiftLineItemInputs(gift.variantId, variantId) : "";
  return `
    <input type='hidden' name='items[0][id]' value='${escapeAttribute2(variantId)}'>
    <input type='hidden' name='items[0][quantity]' value='1'>
    ${contenance ? `<input type='hidden' name='items[0][properties][${escapeAttribute2(contenanceLabel)}]' value='${escapeAttribute2(contenance)}'>` : ""}${giftInputs}`;
}
function renderProductInputs(hit, variantId, assets) {
  return renderAddToCartInputs(hit, variantId, assets.contenanceLabel);
}
function renderQuickBuy(hit, url, assets) {
  const variantId = hit.variant_id ?? hit.objectID ?? "";
  const formId = `quickBuyForm${hit.id ?? variantId}add-${++cardIndex}`;
  const gift = isGiftEligible(hit) ? giftFromHit(hit) : null;
  const giftAttr = gift && "productId" in gift && hit.handle ? ` data-gift-parent-handle='${escapeAttribute2(hit.handle)}' data-gift-parent-id='${escapeAttribute2(variantId)}'` : "";
  return `<c-product-form
    data-action='add'
    class='card-product-quick-buy__container'
  >
    <form id='${escapeAttribute2(formId)}' class='form' action='/cart/add' method='post' novalidate data-type='add-to-cart-form'${giftAttr}>
      <input type='hidden' value='header,popup-add-to-cart' name='sections'>
      ${renderProductInputs(hit, variantId, assets)}
      <div class='card-product-quick-buy__wrapper--content'>
        ${renderQuickBuyButton(hit, url, formId, assets)}
      </div>
      <div class='product-form__error' data-product-form-error style='display:none;'></div>
    </form>
  </c-product-form>`;
}
function renderCard(hit, assets = DEFAULT_CARD_ASSETS, analytics) {
  const url = itemUrl(hit);
  const title = escapeHtml(hit.title);
  const image = renderImage(hit);
  const productPrice = renderProductPrice(hit);
  const price = productPrice ? `<span class='card-product__price label-m-regular'>${escapeHtml(productPrice)}</span>` : "";
  return `
    <article class='card-product' ${renderAnalyticsAttributes(hit, analytics)}>
      <div class='card-product__top'>
        <a aria-label='${escapeAttribute2(hit.title)}' class='card-product_image ${image.className}' href='${escapeAttribute2(url)}' data-algolia-click>
          ${image.html}
        </a>
        ${renderQuickBuy(hit, url, assets)}
        ${renderAddonTags(hit.meta?.custom?.product_tags)}
      </div>
      <div class='card-product_content'>
        <div class='card-product_infos'>
          <div class='card-product_infos_top' data-algolia-click>
            <h3 class='label-m-alternate'>${title}</h3>
            ${renderSubtitle(hit)}
          </div>
          <div class='card-product_infos_bottom'>
            ${renderProductInfo(hit, assets)}
            ${price}
          </div>
        </div>
      </div>
    </article>`;
}

// src/sections/algolia-main-search/gift-product.ts
var GIFT_SECTION_ID = "gift-product-data";
var giftCache = /* @__PURE__ */ new Map();
function routesRoot() {
  const root = window.Shopify?.routes?.root;
  return root && root.length ? root : "/";
}
async function fetchGiftForHandle(handle) {
  const base = routesRoot().replace(/\/$/, "");
  const url = `${base}/products/${encodeURIComponent(handle)}?section_id=${GIFT_SECTION_ID}`;
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) {
    throw new Error(`gift section render failed with status ${response.status}`);
  }
  const html = await response.text();
  const json = new DOMParser().parseFromString(html, "text/html").querySelector("[data-gift-product-json]")?.textContent;
  if (!json) return null;
  const data = JSON.parse(json);
  const variantId = data.variant_id == null || data.variant_id === "" ? "" : String(data.variant_id);
  if (!variantId || data.available === false) return null;
  return { variantId, available: true };
}
function resolveGift(handle) {
  let cached = giftCache.get(handle);
  if (!cached) {
    cached = fetchGiftForHandle(handle).catch((error) => {
      console.warn("[gift-product] resolution failed", handle, error);
      return null;
    });
    giftCache.set(handle, cached);
  }
  return cached;
}
async function hydrateGiftProducts(root) {
  if (!root) return;
  const forms = Array.from(
    root.querySelectorAll(
      "form[data-gift-parent-handle]:not([data-gift-hydrated])"
    )
  );
  if (forms.length === 0) return;
  await Promise.all(
    forms.map(async (form) => {
      const handle = form.dataset.giftParentHandle;
      const parentId = form.dataset.giftParentId;
      form.dataset.giftHydrated = "true";
      if (!handle || !parentId) return;
      const resolved = await resolveGift(handle);
      if (!resolved || !form.isConnected) return;
      form.insertAdjacentHTML(
        "beforeend",
        renderGiftLineItemInputs(resolved.variantId, parentId)
      );
    })
  );
}

// src/sections/algolia-main-search/routing.ts
function buildRouting(indexName, instantsearch, options = {}) {
  const { defaultSortBy = "", enableSort = true } = options;
  return {
    router: instantsearch.routers.history({
      createURL({
        qsModule,
        routeState,
        location
      }) {
        const { origin, pathname } = location;
        const queryString = qsModule.stringify(routeState);
        return queryString ? `${origin}${pathname}?${queryString}` : `${origin}${pathname}`;
      },
      parseURL({
        qsModule,
        location
      }) {
        return qsModule.parse(location.search.slice(1));
      }
    }),
    stateMapping: {
      stateToRoute: (uiState) => {
        const indexState = uiState[indexName] || {};
        const route = {};
        if (indexState.query) route.q = indexState.query;
        if (indexState.page && indexState.page > 1) {
          route.page = String(indexState.page);
        }
        if (indexState.refinementList) {
          Object.entries(indexState.refinementList).forEach(
            ([attribute, values]) => {
              if (values.length) route[`filter.${attribute}`] = values.join("|");
            }
          );
        }
        if (enableSort && indexState.sortBy && indexState.sortBy !== defaultSortBy) {
          route.sort_by = indexState.sortBy;
        }
        return route;
      },
      routeToState: (routeState) => {
        const refinementList = {};
        Object.entries(routeState).forEach(([key, value]) => {
          if (!key.startsWith("filter.")) return;
          const attribute = key.slice("filter.".length);
          refinementList[attribute] = String(value).split("|");
        });
        return {
          [indexName]: {
            query: String(routeState.q || ""),
            ...Object.keys(refinementList).length && { refinementList },
            ...enableSort && routeState.sort_by ? { sortBy: routeState.sort_by } : {},
            ...enableSort && !routeState.sort_by && defaultSortBy ? { sortBy: defaultSortBy } : {}
          }
        };
      }
    }
  };
}

// src/sections/algolia-main-search/search-client.ts
function withoutAnalyticsForEmptyQuery(request) {
  const query = String(request.params?.query ?? "").trim();
  if (query) return request;
  return {
    ...request,
    params: {
      ...request.params,
      analytics: false
    }
  };
}
function withoutEmptyQueryAnalytics(searchClient) {
  const client = searchClient;
  if (typeof client.search !== "function") return searchClient;
  return {
    ...client,
    search(requests) {
      return client.search(requests.map(withoutAnalyticsForEmptyQuery));
    }
  };
}

// src/shared/algolia-rule-push/algolia-rule-push.ts
function isRecord(value) {
  return value !== null && typeof value === "object";
}
function asString(value) {
  return typeof value === "string" ? value.trim() : "";
}
function escapeHtml2(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function escapeAttribute3(value) {
  return escapeHtml2(value);
}
function localizedRoot() {
  return window.Shopify?.routes?.root ?? "/";
}
function joinRootUrl(root, path) {
  return `${root.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}
function normalizeUrl(value) {
  if (!value) return "";
  if (value.startsWith("#") || value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }
  if (!value.startsWith("/")) return "";
  const root = localizedRoot();
  if (root === "/" || value.startsWith(root)) return value;
  return joinRootUrl(root, value);
}
function parseUserDataItem(item) {
  if (typeof item !== "string") return item;
  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
}
function normalizeUserData(userData) {
  const parsedUserData = parseUserDataItem(userData);
  if (Array.isArray(parsedUserData)) {
    return parsedUserData.flatMap(normalizeUserData);
  }
  if (!isRecord(parsedUserData)) return [];
  const list = parsedUserData;
  const nestedList = [list.push, list.pushes, list.items, list.rules].find(
    Array.isArray
  );
  if (nestedList) return normalizeUserData(nestedList);
  return [parsedUserData];
}
function normalizeOrder(value) {
  const order = typeof value === "number" ? value : Number(value);
  if (!Number.isInteger(order) || order < 1) return null;
  return order;
}
function normalizeStyle(value, fallback) {
  return value || fallback;
}
function normalizeButtonType(item) {
  return normalizeStyle(
    asString(item.button?.button_type) || asString(item.button?.button_style),
    "v-primary"
  );
}
function normalizeButtonSize(item) {
  return normalizeStyle(asString(item.button?.button_size), "v-large");
}
function normalizeButtonVariant(item) {
  return normalizeStyle(asString(item.button?.button_variant), "v-dark");
}
function renderBulletIcon() {
  return `<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none' aria-hidden='true'>
    <path d='M9.5 8C9.5 8.55228 9.05228 9 8.5 9C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7C9.05228 7 9.5 7.44772 9.5 8Z' fill='currentColor'/>
  </svg>`;
}
function renderCta(label, url, type, size, variant) {
  return `<a class='cta v-margin-top ${escapeAttribute3(type)} ${escapeAttribute3(size)} ${escapeAttribute3(variant)} v-fit' href='${url}' target='_self' rel='_self'>
    <span class='cta--label'>
      ${renderBulletIcon()}
      <span class='cta--label__text'>${escapeHtml2(label)}</span>
      ${renderBulletIcon()}
    </span>
  </a>`;
}
function renderLink(label, url, type) {
  return `<a class='link ${escapeAttribute3(type)}' href='${url}'>
    <span class='cta--label'>
      <span class='cta--label__text'>${escapeHtml2(label)}</span>
    </span>
  </a>`;
}
function normalizeRulePush(item) {
  const buttonUrl = normalizeUrl(asString(item.button?.button_url));
  const linkUrl = normalizeUrl(asString(item.link?.link_url));
  const visualLink = normalizeUrl(asString(item.visualLink));
  const ctaLink = normalizeUrl(asString(item.ctaLinkLink));
  return {
    buttonLabel: asString(item.button?.button_label) || asString(item.ctaLinkText) || "D\xE9couvrir",
    buttonSize: normalizeButtonSize(item),
    buttonType: normalizeButtonType(item),
    buttonUrl: buttonUrl || ctaLink || linkUrl || visualLink || "#",
    buttonVariant: normalizeButtonVariant(item),
    description: asString(item.content?.description) || asString(item.descr) || asString(item.description),
    imageDesktop: asString(item.media?.media_desktop) || asString(item.visual?.url) || asString(item.visualDesktop),
    imageMobile: asString(item.media?.media_mobile),
    linkLabel: asString(item.link?.link_label),
    linkStyle: normalizeStyle(asString(item.link?.link_style), "v-primary"),
    linkUrl: linkUrl || buttonUrl || ctaLink || visualLink || "#",
    order: normalizeOrder(item.order),
    ratioDesktop: asString(item.media?.ratio_desktop),
    ratioMobile: asString(item.media?.ratio_mobile),
    sectionHeading: asString(item.sectionHeading),
    title: asString(item.content?.title) || asString(item.heading) || asString(item.title)
  };
}
function getRulePushes(userData) {
  return normalizeUserData(userData).map(normalizeRulePush).filter(
    (item) => item.title || item.description || item.imageDesktop || item.buttonUrl !== "#" || item.linkUrl !== "#"
  ).sort(
    (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
  );
}
function renderRulePush(push, options = {}) {
  const title = escapeHtml2(push.title);
  const imageDesktop = escapeAttribute3(push.imageDesktop);
  const imageMobile = escapeAttribute3(push.imageMobile || push.imageDesktop);
  const buttonUrl = escapeAttribute3(push.buttonUrl);
  const linkUrl = escapeAttribute3(push.linkUrl);
  const ratioStyles = [
    push.ratioDesktop ? `--ratio-desktop: ${escapeAttribute3(push.ratioDesktop)}` : "",
    push.ratioMobile ? `--ratio-mobile: ${escapeAttribute3(push.ratioMobile)}` : ""
  ].filter(Boolean).join("; ");
  const styleAttr = ratioStyles ? ` style='${ratioStyles}'` : "";
  const mediaHtml = imageDesktop ? `<a aria-label='${title}' href='${buttonUrl}' class='algolia-rule-push__media'${styleAttr}>
        <picture>
          ${imageMobile ? `<source media='(max-width: 767px)' srcset='${imageMobile}'>` : ""}
          <img src='${imageDesktop}' alt='${title}' loading='lazy'>
        </picture>
      </a>` : "";
  const buttonHtml = push.buttonLabel ? renderCta(
    push.buttonLabel,
    buttonUrl,
    push.buttonType,
    push.buttonSize,
    push.buttonVariant
  ) : "";
  const linkHtml = push.linkLabel ? renderLink(push.linkLabel, linkUrl, push.linkStyle) : "";
  const topHtml = [
    push.sectionHeading && !options.hideSectionHeading ? `<span class='label-s-regular color-secondary'>${escapeHtml2(push.sectionHeading)}</span>` : "",
    push.title ? `<h3 class='label-m-alternate'>${title}</h3>` : "",
    push.description ? `<div class='body-m-light color-secondary description'>${push.description}</div>` : ""
  ].filter(Boolean).join("");
  return `<c-media-card class='media-card algolia-rule-push'>
    <div class='media-container'>
      ${mediaHtml}
    </div>
    <div class='content-container'>
      <div class='inside'>
        ${topHtml ? `<div class='inside__top'>${topHtml}</div>` : ""}
        <div class='inside__bottom'>
          ${buttonHtml}
          ${linkHtml}
        </div>
      </div>
    </div>
  </c-media-card>`;
}
function renderRulePushesByVisualOrder(userData, renderProduct, productCount, startIndex = 0) {
  const pushes = getRulePushes(userData);
  const items = [];
  for (let productIndex = 0; productIndex < productCount; productIndex += 1) {
    const visualPosition = startIndex + productIndex + 1;
    items.push({
      html: renderProduct(productIndex),
      sortIndex: visualPosition
    });
  }
  pushes.forEach((push, pushIndex) => {
    const pushOrder = push.order;
    if (!pushOrder) return;
    const previousPushesCount = pushes.slice(0, pushIndex).filter(
      (previousPush) => previousPush.order && previousPush.order < pushOrder
    ).length;
    items.push({
      html: renderRulePush(push),
      sortIndex: pushOrder - previousPushesCount - 0.5
    });
  });
  return items.sort((a, b) => a.sortIndex - b.sortIndex).map((item) => item.html).join("");
}

// src/sections/algolia-main-search/page-base.ts
var AlgoliaPageBase = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.search = null;
    this.config = null;
  }
  async connectedCallback() {
    this.setNoResultsMessageVisible(false);
    await this.loadDependencies();
    await this.waitForDocumentReady();
    const config = this.readConfig();
    if (!config) return;
    this.config = config;
    const insightsClient = await initAlgoliaInsights(
      config.appId,
      config.apiKey,
      config.indexName
    );
    const instantsearch = window.instantsearch;
    const liteClient = window["algoliasearch/lite"]?.liteClient;
    if (!instantsearch || !liteClient) return;
    const heroInput = document.querySelector(
      '.hero-search input[name="q"]'
    );
    const initialQuery = new URLSearchParams(window.location.search).get("q") || "";
    if (heroInput) heroInput.value = initialQuery;
    this.updateQueryUi(initialQuery);
    this.search = instantsearch({
      indexName: config.indexName,
      searchClient: withoutEmptyQueryAnalytics(
        liteClient(config.appId, config.apiKey)
      ),
      routing: buildRouting(config.indexName, instantsearch, {
        defaultSortBy: config.defaultSortBy
      }),
      future: { preserveSharedStateOnUnmount: true },
      // Reuse our own client so automatic view events share the theme's user
      // token; `false` keeps the app-level automatic insights off entirely
      // when the visitor has not consented.
      insights: insightsClient ? { insightsClient } : false
    });
    const widgets = this.buildWidgets(config, instantsearch, heroInput);
    this.search.addWidgets(widgets);
    this.search.start();
    this.setupDialog();
    this.setupSearchStateHandlers();
    this.setupAlgoliaEventHandlers();
  }
  disconnectedCallback() {
    this.search?.dispose();
  }
  /**
   * Analytics tag(s) attached to every search request of this page, so events
   * can be segmented by page type in Algolia Analytics. Overridden by the
   * collection page to distinguish category browsing from site search.
   */
  searchAnalyticsTags() {
    return ["search-page"];
  }
  updateQueryUi(_query) {
  }
  mergeSortItems(...sortValues) {
    const seen = /* @__PURE__ */ new Set();
    return sortValues.flatMap((value) => parsePairs(value)).filter((item) => {
      if (!item.value || seen.has(item.value)) return false;
      seen.add(item.value);
      return true;
    });
  }
  defaultSortBy(value, sortItems) {
    const defaultSortValue = parsePairs(value)[0]?.value ?? value.trim();
    if (!defaultSortValue) return "";
    if (!sortItems.some((item) => item.value === defaultSortValue)) return "";
    return defaultSortValue;
  }
  withDefaultSortItem(sortItems, defaultSortValue) {
    const defaultSortItem = parsePairs(defaultSortValue)[0];
    if (!defaultSortItem) return sortItems;
    return [
      defaultSortItem,
      ...sortItems.filter((item) => item.value !== defaultSortItem.value)
    ];
  }
  async loadDependencies() {
    await Promise.all([
      loadScript(CDN_ALGOLIASEARCH, SRI_ALGOLIASEARCH),
      loadScript(CDN_INSTANTSEARCH, SRI_INSTANTSEARCH)
    ]);
  }
  waitForDocumentReady() {
    if (document.readyState !== "loading") return Promise.resolve();
    return new Promise((resolve) => {
      document.addEventListener("DOMContentLoaded", () => resolve(), {
        once: true
      });
    });
  }
  readProductCardAssets() {
    return {
      alertIcon: this.querySelector(
        'template[data-algolia-icon="alert"]'
      )?.innerHTML.trim() ?? "",
      notifyMeLabel: this.dataset.notifyMeLabel || "",
      quickBuyIcon: this.querySelector(
        'template[data-algolia-icon="quick-buy"]'
      )?.innerHTML.trim() ?? "",
      quickBuyLabel: this.dataset.quickBuyLabel || "",
      setToComposeLabel: this.dataset.setToComposeLabel || "",
      contenanceLabel: this.dataset.contenanceLabel || "Contenance",
      modelsLabelOne: this.dataset.modelsLabelOne || "+{{ count }} model",
      modelsLabelOther: this.dataset.modelsLabelOther || "+{{ count }} models"
    };
  }
  buildWidgets(config, instantsearch, heroInput) {
    const { connectors, widgets } = instantsearch;
    const facetAttributes = this.requestedFacetAttributes(config.facetPairs);
    const widgetList = [
      widgets.configure({
        facets: facetAttributes,
        ...config.collectionFilter ? { filters: config.collectionFilter } : {},
        analyticsTags: this.searchAnalyticsTags(),
        attributesToHighlight: [],
        attributesToRetrieve: productAttributesToRetrieve(),
        clickAnalytics: true,
        hitsPerPage: ALGOLIA_HITS_PER_PAGE,
        ignorePlurals: true,
        maxValuesPerFacet: ALGOLIA_MAX_VALUES_PER_FACET,
        removeWordsIfNoResults: "allOptional",
        typoTolerance: true,
        userToken: getAlgoliaUserToken()
      })
    ];
    this.addSearchBoxWidget(widgetList, connectors, heroInput);
    this.addStatsWidget(widgetList, connectors);
    this.addCurrentRefinementsWidget(widgetList, connectors);
    this.addSortWidget(widgetList, connectors, config.sortItems);
    this.addFacetWidgets(widgetList, widgets, config.facetPairs);
    this.addInfiniteHitsWidget(widgetList, instantsearch, config.indexName);
    return widgetList;
  }
  facetAttributes(facetPairs) {
    return facetPairs.map(({ value }) => value).filter(Boolean);
  }
  requestedFacetAttributes(facetPairs) {
    const facetAttributes = this.facetAttributes(facetPairs);
    return facetAttributes.length ? facetAttributes : ["*"];
  }
  addSearchBoxWidget(widgetList, connectors, heroInput) {
    const heroForm = document.querySelector(".hero-search form");
    heroForm?.addEventListener("submit", (event) => event.preventDefault());
    let refine = null;
    let debounce = null;
    const customSearchBox = connectors.connectSearchBox(
      ({
        query,
        refine: nextRefine
      }) => {
        if (heroInput && document.activeElement !== heroInput) {
          heroInput.value = query;
        }
        this.updateQueryUi(query);
        refine = nextRefine;
      }
    );
    widgetList.push(
      customSearchBox({
        queryHook: (query, search) => {
          if (debounce) clearTimeout(debounce);
          const nextQuery = query.trim();
          const minLength = nextQuery === "34" ? 2 : MIN_QUERY_LEN;
          if (nextQuery.length > 0 && nextQuery.length < minLength) return;
          debounce = setTimeout(() => search(nextQuery), SEARCH_DEBOUNCE_MS);
        }
      })
    );
    heroInput?.addEventListener("input", () => {
      this.updateQueryUi(heroInput.value);
      this.setNoResultsMessageVisible(false);
      refine?.(heroInput.value);
    });
  }
  addStatsWidget(widgetList, connectors) {
    const statsEl = document.querySelector("[data-ais-stats]");
    const applyLabelEl = document.querySelector("[data-ais-apply-label]");
    const applyBtn = document.querySelector(
      "[data-ais-dialog-close]"
    );
    if (!statsEl) return;
    const customStats = connectors.connectStats(
      ({ nbHits }) => {
        statsEl.innerHTML = `<span class='label-m-regular'>${nbHits} article${nbHits > 1 ? "s" : ""}</span>`;
        if (!applyLabelEl || !applyBtn) return;
        const template = nbHits === 1 ? applyBtn.dataset.applyOne : applyBtn.dataset.applyOther;
        applyLabelEl.textContent = template?.replace("{count}", String(nbHits)) ?? `Apply (${nbHits})`;
      }
    );
    widgetList.push(customStats({}));
  }
  addCurrentRefinementsWidget(widgetList, connectors) {
    const currentRefEl = document.querySelector(
      "[data-ais-current-refinements]"
    );
    const clearEl = document.querySelector("[data-ais-clear]");
    const resetEl = document.querySelector("[data-ais-reset-all]");
    if (!currentRefEl) return;
    const customCurrentRefinements = connectors.connectCurrentRefinements(
      ({
        items,
        refine
      }) => {
        const allRefinements = items.flatMap((item) => item.refinements);
        if (allRefinements.length === 0) {
          currentRefEl.innerHTML = "";
          if (clearEl) clearEl.innerHTML = "";
          if (resetEl) resetEl.hidden = true;
          return;
        }
        currentRefEl.innerHTML = this.renderCurrentRefinements(allRefinements);
        currentRefEl.querySelectorAll("[data-ais-remove]").forEach((element) => {
          element.addEventListener("click", () => {
            refine({
              attribute: element.dataset.attribute,
              operator: element.dataset.operator,
              type: element.dataset.type,
              value: element.dataset.value
            });
          });
        });
        this.renderClearRefinements(clearEl, items, refine);
        this.renderResetRefinements(resetEl, items, refine);
      }
    );
    widgetList.push(customCurrentRefinements({ container: currentRefEl }));
  }
  renderCurrentRefinements(refinements) {
    return `
      <ul class='filter-bar_list-tag'>
        ${refinements.map(
      (refinement) => `
              <li
                class='tag_filter label-m-light'
                data-ais-remove
                data-attribute='${refinement.attribute ?? ""}'
                data-value='${String(refinement.value).replace(/'/g, "&#39;")}'
                data-type='${refinement.type ?? ""}'
                data-operator='${refinement.operator ?? ""}'
              >
                <span>${formatFacetLabel(
        refinement.attribute,
        refinement.label,
        refinement.value
      )}</span>
                ${ICON_CROSS_SVG}
              </li>`
    ).join("")}
      </ul>`;
  }
  renderClearRefinements(clearEl, items, refine) {
    if (!clearEl) return;
    const clearLabel = clearEl instanceof HTMLElement ? clearEl.dataset.clearLabel || "Deselect all" : "Deselect all";
    clearEl.innerHTML = `<button class='link fff v-secondary m-0' style="margin:0;" data-ais-clear-all>
      <span class='cta--label'>
        <span class='cta--label__text'>${clearLabel}</span>
      </span>
    </button>`;
    clearEl.querySelector("[data-ais-clear-all]")?.addEventListener("click", () => {
      items.forEach(
        (item) => item.refinements.forEach((refinement) => refine(refinement))
      );
    });
  }
  renderResetRefinements(resetEl, items, refine) {
    if (!resetEl) return;
    resetEl.hidden = false;
    resetEl.onclick = () => {
      items.forEach(
        (item) => item.refinements.forEach((refinement) => refine(refinement))
      );
    };
  }
  addSortWidget(widgetList, connectors, sortItems) {
    const sortEl = document.querySelector("[data-ais-sort]");
    if (!sortEl || sortItems.length === 0) {
      document.querySelector("[data-ais-sort-fieldset]")?.remove();
      return;
    }
    const customSortBy = connectors.connectSortBy(
      ({
        options,
        currentRefinement,
        refine
      }) => {
        sortEl.innerHTML = options.map(
          (option) => `
              <div class='input-radio'>
                <input
                  type='radio'
                  id='ais-sort-${option.value}'
                  name='ais-sort-by'
                  value='${option.value}'
                  ${option.value === currentRefinement ? "checked" : ""}
                >
                <label for='ais-sort-${option.value}'>${option.label}</label>
              </div>`
        ).join("");
        sortEl.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.addEventListener("change", () => refine(input.value));
        });
      }
    );
    widgetList.push(customSortBy({ container: sortEl, items: sortItems }));
  }
  addFacetWidgets(widgetList, widgets, facetPairs) {
    const refinementsEl = document.querySelector("[data-ais-refinements]");
    if (!refinementsEl) return;
    const facetActionLabels = this.readFacetActionLabels(refinementsEl);
    let localeLabels = {};
    try {
      localeLabels = JSON.parse(
        refinementsEl.dataset.facetLabels || "{}"
      );
    } catch {
      localeLabels = {};
    }
    const labelMap = Object.fromEntries(
      facetPairs.map(({ value, label }) => [value, label])
    );
    widgetList.push(
      widgets.dynamicWidgets({
        container: refinementsEl,
        facets: this.requestedFacetAttributes(facetPairs),
        // Masquage temporaire : les attributs restent demandés à Algolia, on
        // retire seulement ceux à masquer de la liste rendue.
        transformItems: (attributes) => attributes.filter((attribute) => !isHiddenFacet(attribute)),
        fallbackWidget: ({
          attribute,
          container
        }) => {
          const localeKey = attribute.split(".").pop() ?? attribute;
          const label = localeLabels[attribute] || localeLabels[localeKey] || labelMap[attribute] || labelFromAttr(attribute);
          const safeId = buildFacetDetails(
            container,
            attribute,
            label,
            facetActionLabels
          );
          return widgets.refinementList({
            attribute,
            container: container.querySelector(`#${safeId}`),
            cssClasses: {
              count: "filter_count-product",
              disabledShowMore: "hide",
              item: "input-checkbox",
              list: "ais-rl-list",
              showMore: "link v-secondary m-0 ais-show-more"
            },
            limit: 10,
            showMore: true,
            showMoreLimit: ALGOLIA_MAX_VALUES_PER_FACET,
            templates: {
              showMoreText: ({ isShowingMore }) => `<span class='cta--label'>
                  <span class='cta--label__text'>${isShowingMore ? facetActionLabels.showLess : facetActionLabels.showMore}</span>
                </span>`
            },
            transformItems: (items) => formatFacetItems(attribute, items)
          });
        },
        widgets: []
      })
    );
  }
  readFacetActionLabels(refinementsEl) {
    if (!(refinementsEl instanceof HTMLElement)) {
      return {
        deselect: "Deselect all",
        select: "Select all",
        showLess: "See less",
        showMore: "See all"
      };
    }
    return {
      deselect: refinementsEl.dataset.deselectLabel || "Deselect all",
      select: refinementsEl.dataset.selectLabel || "Select all",
      showLess: refinementsEl.dataset.showLessLabel || "See less",
      showMore: refinementsEl.dataset.showMoreLabel || "See all"
    };
  }
  addInfiniteHitsWidget(widgetList, instantsearch, indexName) {
    const hitsEl = this.querySelector("[data-ais-hits]");
    if (!hitsEl) return;
    const { connectors } = instantsearch;
    const cardAssets = this.readProductCardAssets();
    const noResultsTemplate = this.readNoResultsTemplate();
    let showMore = null;
    let renderedCount = 0;
    let hasRenderedFirstPage = false;
    let isLoadingMore = false;
    let isLastRenderedPage = false;
    let pendingInitialPageLoads = this.readInitialPageTarget() - 1;
    const loadNextPage = () => {
      if (!hasRenderedFirstPage || isLoadingMore || isLastRenderedPage) return;
      isLoadingMore = true;
      showMore?.();
    };
    const customInfiniteHits = connectors.connectInfiniteHits(
      (options, isFirstRender) => {
        showMore = options.showMore;
        isLastRenderedPage = options.isLastPage;
        if (isFirstRender) {
          this.renderHitsSkeleton(hitsEl, loadNextPage);
          return;
        }
        const grid = hitsEl.querySelector("[data-ais-grid]");
        if (!grid) return;
        const page = options.results?.page ?? 0;
        if (page === 0) {
          renderedCount = this.renderFirstHitsPage(
            grid,
            options,
            cardAssets,
            noResultsTemplate,
            indexName
          );
          hasRenderedFirstPage = true;
          if (options.results) {
            this.updateEmptyState(
              options.results.query ?? "",
              options.results.nbHits ?? options.results.hits.length ?? 0
            );
          }
        } else if (page > 0) {
          isLoadingMore = false;
          renderedCount = this.appendHitsPage(
            grid,
            options.currentPageHits ?? options.hits.slice(renderedCount),
            renderedCount,
            options.results?.userData ?? [],
            cardAssets,
            indexName,
            options.results?.queryID
          );
        }
        this.updateHitsFooter(hitsEl, options, renderedCount);
        this.updatePaginationHeadTags(
          options.results?.page ?? 0,
          options.results?.nbPages ?? 0
        );
        if (pendingInitialPageLoads > 0 && renderedCount > 0 && !options.isLastPage) {
          pendingInitialPageLoads -= 1;
          loadNextPage();
        }
      }
    );
    widgetList.push(
      customInfiniteHits({
        ...instantsearch.createInfiniteHitsSessionStorageCache ? { cache: instantsearch.createInfiniteHitsSessionStorageCache() } : {}
      })
    );
  }
  renderHitsSkeleton(hitsEl, onLoadMore) {
    const loadMoreLabel = this.dataset.productLoadMoreLabel || "Display more";
    hitsEl.innerHTML = `
      <div data-ais-grid></div>
      <nav data-ais-pagination class='sr-only' aria-label='Pagination'></nav>
      <div data-rerender-more style='display:none'>
        <span class='label-m-regular'></span>
        <button
          class='button button-primary button-primary--no-margin'
          data-ais-load-more-btn
        >
          <span class='button__label label-s-alternate'>
            ${ICON_BULLET}<span>${loadMoreLabel}</span>${ICON_BULLET}
          </span>
        </button>
      </div>`;
    hitsEl.querySelector("[data-ais-load-more-btn]")?.addEventListener("click", (event) => {
      if (event.currentTarget instanceof HTMLButtonElement) {
        event.currentTarget.blur();
      }
      onLoadMore();
    });
  }
  /**
   * Hook invoked after the first hits page renders, with the search query and
   * total hit count. No-op in the base class — the search page overrides this
   * to toggle its empty-state "Trending items" grid. The collection page keeps
   * the default behavior (full listing) and must NOT use this.
   */
  updateEmptyState(_query, _hitCount) {
  }
  renderFirstHitsPage(grid, { results }, cardAssets, noResultsTemplate, indexName) {
    const pageHits = results?.hits ?? [];
    grid.classList.toggle("collection-grid", pageHits.length > 0);
    grid.querySelector(".no-result-search")?.remove();
    grid.innerHTML = pageHits.length === 0 ? this.renderNoResults(noResultsTemplate, results?.query) : this.renderHitsWithRulePushes(
      pageHits,
      0,
      results?.userData ?? [],
      cardAssets,
      indexName,
      results?.queryID
    );
    void hydrateGiftProducts(grid);
    return pageHits.length;
  }
  appendHitsPage(grid, newHits, renderedCount, userData, cardAssets, indexName, queryID) {
    if (newHits.length === 0) return renderedCount;
    grid.classList.add("collection-grid");
    grid.querySelector(".no-result-search")?.remove();
    grid.insertAdjacentHTML(
      "beforeend",
      this.renderHitsWithRulePushes(
        newHits,
        renderedCount,
        userData,
        cardAssets,
        indexName,
        queryID
      )
    );
    void hydrateGiftProducts(grid);
    return renderedCount + newHits.length;
  }
  renderHitsWithRulePushes(hits, startIndex, userData, cardAssets, indexName, queryID) {
    return renderRulePushesByVisualOrder(
      userData,
      (productIndex) => renderCard(hits[productIndex], cardAssets, {
        indexName,
        position: startIndex + productIndex + 1,
        queryID
      }),
      hits.length,
      startIndex
    );
  }
  readNoResultsTemplate() {
    return this.querySelector(
      "template[data-ais-no-results]"
    )?.innerHTML.trim() ?? "";
  }
  renderNoResults(noResultsTemplate, query) {
    if (noResultsTemplate) return noResultsTemplate;
    if (!query) return "";
    return `<div class='no-result-search'>
      <p class='body-m-light'>Aucun r\xE9sultat pour \xAB ${escapeHtml(query)} \xBB.</p>
    </div>`;
  }
  updateHitsFooter(hitsEl, { isLastPage, results }, renderedCount) {
    const moreWrapper = hitsEl.querySelector(
      "[data-rerender-more]"
    );
    const countSpan = moreWrapper?.querySelector(".label-m-regular");
    const button = moreWrapper?.querySelector(
      "[data-ais-load-more-btn]"
    );
    const paginationNav = hitsEl.querySelector(
      "[data-ais-pagination]"
    );
    const totalHits = results?.nbHits ?? 0;
    const totalPages = results?.nbPages ?? 0;
    const currentPage = (results?.page ?? 0) + 1;
    const query = results?.query?.trim() ?? "";
    this.updateQueryUi(query);
    if (countSpan) {
      const showingItemsTemplate = this.dataset.productShowingItemsTemplate || "You have seen CURRENT_ITEMS of TOTAL_ITEMS";
      countSpan.textContent = renderedCount > 0 && totalHits > 0 ? showingItemsTemplate.replace("CURRENT_ITEMS", String(renderedCount)).replace("TOTAL_ITEMS", String(totalHits)) : "";
    }
    if (moreWrapper)
      moreWrapper.style.display = renderedCount === 0 ? "none" : "";
    if (button) button.style.display = isLastPage ? "none" : "";
    if (paginationNav) {
      paginationNav.innerHTML = this.renderPaginationLinks(
        currentPage,
        totalPages
      );
    }
    this.setNoResultsMessageVisible(Boolean(query && totalHits === 0));
  }
  renderPaginationLinks(currentPage, totalPages) {
    if (totalPages <= 1) return "";
    return Array.from({ length: totalPages }, (_, index) => {
      const page = index + 1;
      const url = this.buildPageUrl(page);
      return `<a href='${url}'${page === currentPage ? " aria-current='page'" : ""}>Page ${page}</a>`;
    }).join("");
  }
  updatePaginationHeadTags(currentPageIndex, totalPages) {
    const currentPage = currentPageIndex + 1;
    this.setHeadLink("canonical", this.buildAbsolutePageUrl(currentPage));
    this.removeHeadLink("prev");
    this.removeHeadLink("next");
    if (totalPages <= 1) return;
    if (currentPage > 1) {
      this.setHeadLink("prev", this.buildAbsolutePageUrl(currentPage - 1));
    }
    if (currentPage < totalPages) {
      this.setHeadLink("next", this.buildAbsolutePageUrl(currentPage + 1));
    }
  }
  setHeadLink(rel, href) {
    const selector = rel === "canonical" ? "link[rel='canonical']" : `link[rel='${rel}'][data-algolia-pagination]`;
    let link = document.head.querySelector(selector);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      if (rel !== "canonical") link.dataset.algoliaPagination = "true";
      document.head.appendChild(link);
    }
    link.href = href;
  }
  removeHeadLink(rel) {
    document.head.querySelectorAll(`link[rel='${rel}']`).forEach((link) => link.remove());
  }
  buildAbsolutePageUrl(page) {
    return new URL(this.buildPageUrl(page), window.location.origin).href;
  }
  buildPageUrl(page) {
    const url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete("page");
    } else {
      url.searchParams.set("page", String(page));
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }
  readInitialPageTarget() {
    const page = Number(new URLSearchParams(window.location.search).get("page"));
    if (!Number.isInteger(page) || page <= 1) return 1;
    return Math.min(page, ALGOLIA_MAX_INITIAL_PRELOAD_PAGES);
  }
  setNoResultsMessageVisible(isVisible) {
    document.querySelectorAll("[data-ais-no-results-message]").forEach((message) => {
      message.hidden = !isVisible;
      message.style.display = isVisible ? "" : "none";
      message.setAttribute("aria-hidden", String(!isVisible));
    });
  }
  setupSearchStateHandlers() {
    if (!this.search) return;
    this.search.mainHelper?.on("search", () => {
      this.setNoResultsMessageVisible(false);
      document.documentElement.classList.add("ais-searching");
    });
    let skeletonCleaned = false;
    this.search.on("render", () => {
      document.documentElement.classList.remove("ais-searching");
      if (skeletonCleaned) return;
      document.querySelectorAll("[data-ais-refinements] .ais-skel-group").forEach((element) => element.remove());
      skeletonCleaned = true;
    });
    this.search.on("render", () => this.setupFacetActionHandlers());
  }
  setupAlgoliaEventHandlers() {
    this.addEventListener("click", (event) => {
      if (!(event.target instanceof Element)) return;
      const clickEl = event.target.closest("[data-algolia-click]");
      if (clickEl) sendAlgoliaClickEvent(clickEl);
    });
    this.addEventListener(
      "submit",
      (event) => {
        if (!(event.target instanceof Element)) return;
        const conversionEl = event.target.closest("[data-algolia-product]");
        if (conversionEl) trackAlgoliaAddToCart(conversionEl);
      },
      true
    );
  }
  setupFacetActionHandlers() {
    document.querySelectorAll("[data-ais-facet-toggle]").forEach((button) => {
      const facet = button.closest("[data-ais-facet]");
      if (!facet) return;
      const inputs = [
        ...facet.querySelectorAll(
          'input[type="checkbox"]:not(:disabled)'
        )
      ];
      const hasCheckedInput = inputs.some((input) => input.checked);
      const selectLabel = button.dataset.selectLabel || "Select all";
      const deselectLabel = button.dataset.deselectLabel || "Deselect all";
      const hasSelectableInputs = Boolean(inputs.length);
      const label = button.querySelector(
        "[data-ais-facet-toggle-label]"
      );
      const buttonLabel = hasCheckedInput ? deselectLabel : selectLabel;
      if (label) label.textContent = buttonLabel;
      button.dataset.hasCheckedInput = String(hasCheckedInput);
      button.setAttribute("aria-label", buttonLabel);
      button.disabled = !hasSelectableInputs;
      if (button.dataset.bound === "true") return;
      button.dataset.bound = "true";
      button.addEventListener("click", () => {
        const nextInputs = [
          ...facet.querySelectorAll(
            'input[type="checkbox"]:not(:disabled)'
          )
        ];
        const shouldSelect = !nextInputs.some((input) => input.checked);
        const attribute = facet instanceof HTMLElement ? facet.dataset.aisFacetAttribute : void 0;
        if (this.applyBulkFacetSelection(attribute, nextInputs, shouldSelect)) {
          return;
        }
        nextInputs.filter((input) => shouldSelect ? !input.checked : input.checked).forEach((input) => input.click());
      });
    });
  }
  /**
   * Applies a "select all" / "deselect all" facet action as a single Algolia
   * request. Instead of clicking each checkbox (which makes the refinementList
   * widget call `.search()` once per value → N requests), we batch every
   * disjunctive-facet refinement onto the InstantSearch helper and trigger a
   * single `search()` — exactly like a single filter click does. Returns `false`
   * when the helper isn't available so the caller can fall back.
   */
  applyBulkFacetSelection(attribute, inputs, shouldSelect) {
    const helper = this.getSearchHelper();
    if (!helper || !attribute) return false;
    if (!helper.state?.disjunctiveFacets?.includes(attribute)) return false;
    let mutated = false;
    inputs.forEach((input) => {
      const value = input.value;
      const isRefined = helper.state?.isDisjunctiveFacetRefined?.(attribute, value) ?? input.checked;
      if (shouldSelect && !isRefined) {
        helper.addDisjunctiveFacetRefinement(attribute, value);
        mutated = true;
      } else if (!shouldSelect && isRefined) {
        helper.removeDisjunctiveFacetRefinement(attribute, value);
        mutated = true;
      }
    });
    if (mutated) helper.search();
    return true;
  }
  getSearchHelper() {
    const helper = this.search?.helper;
    if (helper && typeof helper.addDisjunctiveFacetRefinement === "function" && typeof helper.removeDisjunctiveFacetRefinement === "function" && typeof helper.search === "function") {
      return helper;
    }
    return null;
  }
  setupDialog() {
    const dialog = document.querySelector(
      "[data-filter-dialog]"
    );
    if (!dialog) return;
    const toggleDialog = () => {
      document.documentElement.classList.toggle("is-overflow-hidden");
      if (dialog.open) {
        setTimeout(() => dialog.close(), 900);
        return;
      }
      dialog.showModal();
    };
    document.querySelectorAll("[data-btn-toggle-filter]").forEach((button) => {
      button.addEventListener("click", toggleDialog);
    });
    dialog.addEventListener("click", (event) => {
      const rect = dialog.getBoundingClientRect();
      const inDialog = [
        rect.top <= event.clientY,
        event.clientY <= rect.top + rect.height,
        rect.left <= event.clientX,
        event.clientX <= rect.left + rect.width
      ].every(Boolean);
      if (!inDialog) toggleDialog();
    });
    document.querySelector("[data-ais-dialog-close]")?.addEventListener("click", () => {
      document.documentElement.classList.remove("is-overflow-hidden");
      setTimeout(() => dialog.close(), 900);
    });
  }
};

// src/sections/algolia-main-collection/algolia-main-collection.ts
var AlgoliaCollectionPage = class extends AlgoliaPageBase {
  searchAnalyticsTags() {
    return ["collection-page"];
  }
  readConfig() {
    const {
      algoliaAppId,
      algoliaApiKey,
      algoliaIndexName,
      algoliaCollectionAttribute = "collections",
      algoliaCollectionId = "",
      algoliaCollectionHandle = "",
      algoliaFacets = "",
      algoliaDefaultSort: sectionDefaultSort = "",
      algoliaSort: sectionSort = ""
    } = this.dataset;
    const sortConfig = document.querySelector(
      "[data-ais-sort-config]"
    );
    const filterDefaultSort = sortConfig?.dataset.algoliaDefaultSort ?? "";
    const filterSort = sortConfig?.dataset.algoliaSort ?? "";
    const defaultSortValue = sectionDefaultSort || filterDefaultSort;
    if (!algoliaAppId || !algoliaApiKey || !algoliaIndexName) return null;
    const sortItems = this.withDefaultSortItem(
      this.mergeSortItems(sectionSort, filterSort),
      defaultSortValue
    );
    return {
      apiKey: algoliaApiKey,
      appId: algoliaAppId,
      collectionFilter: this.buildCollectionFilter(
        algoliaCollectionAttribute,
        this.resolveCollectionValue(
          algoliaCollectionAttribute,
          algoliaCollectionId,
          algoliaCollectionHandle
        )
      ),
      defaultSortBy: this.defaultSortBy(defaultSortValue, sortItems),
      facetPairs: parsePairs(algoliaFacets),
      indexName: algoliaIndexName,
      sortItems
    };
  }
  // The Algolia Shopify index carries both `collections` (handles) and
  // `collection_ids` (numeric ids), so the filter value follows the configured
  // facet attribute. Any other attribute name falls back to the id.
  resolveCollectionValue(attribute, collectionId, collectionHandle) {
    const cleanAttribute = attribute.trim();
    if (cleanAttribute === "collections" || /handle/i.test(cleanAttribute)) {
      return collectionHandle;
    }
    return collectionId;
  }
  buildCollectionFilter(attribute, collectionId) {
    const cleanAttribute = attribute.trim();
    const cleanCollectionId = collectionId.trim();
    if (!cleanAttribute || !cleanCollectionId) return "";
    if (/^\d+$/.test(cleanCollectionId)) {
      return `${cleanAttribute}:${cleanCollectionId}`;
    }
    return `${cleanAttribute}:"${cleanCollectionId.replace(/"/g, '\\"')}"`;
  }
};
if (!customElements.get("algolia-collection-page")) {
  customElements.define("algolia-collection-page", AlgoliaCollectionPage);
}
